import { Component, ElementRef, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { EventService } from '../../../core/services/event.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { TimeParserService } from '../../../core/services/time-parser.service';
import { UtilityService } from '../../../core/services/utility.service';

import { CrewTimecardGridService } from '../crew-timecard-grid/services/crew-timecard-grid.service';
import { CrewTimecardDataService } from '../crew-timecard-grid/services/crew-timecard-data.service'
import { CrewTimecardManagerService } from '../crew-timecard-grid/services/crew-timecard-manager.service'
import { EditCellValueModalComponent } from 'src/app/modals/crew-timecard/edit-cell-value-modal/edit-cell-value-modal.component';
import { CopyCrewLineModalComponent } from '../../../modals/crew-timecard/copy-crew-line-modal/copy-crew-line-modal.component';
import { WarningModalComponent } from '../../../modals/shared/warning-modal/warning-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';

let _this;

@Component({
  selector: 'app-crew-timecard-grid',
  templateUrl: './crew-timecard-grid.component.html',
  styleUrls: ['./crew-timecard-grid.component.css'],
  providers: [CrewTimecardDataService, CrewTimecardManagerService]
})

export class CrewTimecardGridComponent implements OnInit {
	portalSettings: any;
	employeeInfo: any;
  crewTimecardID: string;
  dataTable: webix.ui.datatable;
	crewTimecardDataService: CrewTimecardDataService;
	timeParserService: TimeParserService;

	amountEarnCodes: any[];
	amountPayTypes: any[];
	callback: any;
	dependentQueue: any[];
	columnInfoByEmployee: any;
	columnOptions: any[];
	columnRules: any;
	currentCell: any;
	currentEmployeeColumns: {};
	gridData: any;
	height: number;
	lastRequestedEmployeeDefault: any;
	lastUsedList: any[];
	leftSplit: number;
	rawRows: any[];
	rowKeysToIgnore: any[] = ["PostDate", "DailyTime", "IsRowAggregate"];

	nextEditor: any;
	savedValues: any;

	mobileMode: boolean = false;
  rawData: any;
  root: ElementRef;
	sharedColumnInfo: any[];
	usageMode: string;

	//caching variables
	employeeList: any[];
	unfilteredEmployeeList: any[];
	bulkEmployeeList: any[];
	employeeListBound: boolean;
	employeesToExclude: any[];
	lookupValuesCache: any;
	cacheByColumnValue: any;
	employeeLockStatus: any;

	//grid status variables
	addingRow: boolean;
	equipmentAutoSelectRebind: boolean;
	firstRowCopy: any;
	isReadOnlyGridTime: boolean;
	lastEditedCell: any;
	lastRequestedRow: any;
	largestSortID: any;
	processingRow: boolean;
	rebindingEmployee: boolean;
	tableSort: string;
	tableReverse: boolean;
	tabPressed: string;
  
  constructor(
    private crewTimecardGridService: CrewTimecardGridService,
		private employeeInfoService: EmployeeInfoService,
		private bsModalService: BsModalService,
    portalSettingsService: PortalSettingsService,
    timeParserService: TimeParserService,
    crewTimecardDataService: CrewTimecardDataService,
		private crewTimecardManagerService: CrewTimecardManagerService,
		private ngbmodalService: NgbModal,
		private eventService: EventService,
		private utilityService: UtilityService,
    root: ElementRef
	) {
		this.portalSettings = portalSettingsService.getPortalSettings();
		this.employeeInfo = employeeInfoService.getEmployeeInfo();
		this.crewTimecardDataService = crewTimecardDataService;
		this.timeParserService = timeParserService;
		this.root = root;
		this.tableSort = sessionStorage.getItem("CrewTableSort");
		this.tableReverse = sessionStorage.getItem("CrewTableReverse") == "true";
		this.isReadOnlyGridTime = this.employeeInfo.IsReadOnlyGridTime
		_this = this;
    //TODO see if other config values are necessary
	}

	ngOnInit(): void {
		this.mobileMode = this.utilityService.isMobileMode();
		this.customizeWebix();
		this.windowResize();
	}

	getDataService() {
		return this.crewTimecardDataService;
	}

	getRowProperties() {
		return this.gridData.rowPropertyNames;
  }

	employeeChanged() {
		if (this.crewTimecardDataService.timecardLoaded && !this.crewTimecardDataService.unsavedChanges && !this.crewTimecardDataService.rowDeleted) {
			this.crewTimecardDataService.initRowCounts();
			if (this.crewTimecardDataService.payPeriod.EnableCrews)
				this.filterByEmployeeMultiple();
			else
				this.filterByEmployee();
		}
  }

  loadTimecard(crewTimecardID, callback: any = null) {
    this.crewTimecardID = crewTimecardID;
		this.initValues();
		this.callback = callback;
    //TODO do emplockstatus and employeecolumn need to be nested or can it run in parallel?
    this.getEmployeeLockStatus();
    this.getEmployeeColumns();

    //get shared column info
    this.crewTimecardGridService.getColumnsByPRCoGroup(this.crewTimecardDataService.payPeriod.PRCo, this.crewTimecardDataService.payPeriod.PRGroup, "C").then((response) => {
      $.each(response, (key, val: any) => {
        this.sharedColumnInfo[val.ColumnName] = val;
      });
      this.getTimecardData();
    });    
  }

  private initValues() {
    if (this.dataTable != null)
			this.dataTable.destructor();
		this.amountEarnCodes = [];
		this.amountPayTypes = [];
		this.bulkEmployeeList = [];
		this.cacheByColumnValue = {};
		this.callback = null;
		this.crewTimecardDataService.initValues();
		this.columnInfoByEmployee = {};
		this.columnOptions = [];
		this.dependentQueue = [];
		this.employeeList = [];
		this.employeeListBound = false;
		this.employeeLockStatus = {};
		this.employeesToExclude = [];
		this.lastRequestedEmployeeDefault = null;
		this.crewTimecardDataService.loadingValues = false;
		this.lookupValuesCache = {};
		this.nextEditor = null;
		this.sharedColumnInfo = [];
		this.unfilteredEmployeeList = [];
		this.largestSortID = 0;

		//get expense earncodes and pay types
		let amountBasedEarnCodesSetting = this.portalSettings["AmountBasedEarnCodes"].ConfigValue;
		if (amountBasedEarnCodesSetting != null) {
			this.amountEarnCodes = amountBasedEarnCodesSetting.split(",");
		}

		var amountBasedPayTypesSetting = this.portalSettings["AmountBasedPayTypes"].ConfigValue;
		if (amountBasedPayTypesSetting != null) {
			this.amountPayTypes = amountBasedPayTypesSetting.split(",");
		}
  }

  //methods for getting and processing timecard grid data
	private getTimecardData() {
		try {
			this.crewTimecardGridService.getCrewTimecardData(
				this.crewTimecardDataService.payPeriod.PRPCKeyID,
				this.crewTimecardDataService.template.CrewTemplateID).then((response) => {
					this.crewTimecardDataService.timecardLoaded = true;
					if (response == null || response == "") {
						this.crewTimecardDataService.alertType = "default";
						this.crewTimecardDataService.alertMsg = "Please add column groups to your template.";
					}
					else {
						this.rawData = response;
						this.checkRawData();
					}
				});
		} catch (err) {
			if ("PR Timecard missing Shift or Earncode") {
				this.crewTimecardDataService.alertType = "danger";
				this.crewTimecardDataService.alertMsg = "Payroll timecard requires EarnCode or Shift as a column header.Please modify your Grid Timecard layout.";
			}
			else {
				this.crewTimecardDataService.alertType = "danger";
				this.crewTimecardDataService.alertMsg = "An error occurred while loading the timecard.";
      }
			
    }
		
  }

  private checkRawData() {
    //TODO implement
    this.getEmployeesList();
  }

  //extracts employees from the timecard data to populate the employee filter
  private getEmployeesList() {
		let  employeeDropdownList = [];
		if (this.rawData.TimecardData.Employee != null) {
			if (this.rawData.TimecardData.Employee[0] != null) {
				$.each(this.rawData.TimecardData.Employee, (key, val) => {

					if (val["@Value"] != "" && employeeDropdownList.indexOf(val["@Value"]) == -1) {
						employeeDropdownList.push({ Value: val["@Value"], Label: val["@Label"] });
					}
				});
			}
			else if (this.rawData.TimecardData.Employee["@Value"] != null && this.rawData.TimecardData.Employee["@Value"] != "") {
				employeeDropdownList.push({ Value: this.rawData.TimecardData.Employee["@Value"], Label: this.rawData.TimecardData.Employee["@Label"] });
			}
		}

		employeeDropdownList.sort(this.employeeDropdownSort);
		let multiselectEmployeesList = [];
		if (this.crewTimecardDataService.payPeriod.EnableCrews)
			multiselectEmployeesList = _.cloneDeep(employeeDropdownList);
		employeeDropdownList.unshift({ Value: "all", Label: "All Employees" });
		this.crewTimecardDataService.employees = employeeDropdownList;
		this.crewTimecardDataService.multiSelectEmployees = multiselectEmployeesList
		if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled)
			this.crewTimecardDataService.timeWorked.setEmployeeList(this.crewTimecardDataService.employees);
		//check that selected employee is in the list
		if (this.crewTimecardDataService.selectedEmployee != null && this.crewTimecardDataService.selectedEmployee != "all") {
			let employeeFound = false;
			$.each(this.crewTimecardDataService.employees, (key, val) => {
				if (val.Value == this.crewTimecardDataService.selectedEmployee) {
					employeeFound = true;
					if (this.crewTimecardDataService.payPeriod.EnableCrews) {
						this.crewTimecardDataService.selectedEmployees = [val];
					}	
					return false;
				}
			});
			if (!employeeFound) {
				this.crewTimecardDataService.selectedEmployee = "all";
				if (this.crewTimecardDataService.employees.length == 2)
					this.crewTimecardDataService.timeWorked.setEmployee(this.crewTimecardDataService.employees[1].Value);
				else
					this.crewTimecardDataService.timeWorked.setEmployee(null);
			}
		}
		else {
			this.crewTimecardDataService.selectedEmployee = "all";
			if (this.crewTimecardDataService.employees.length == 2) 
				this.crewTimecardDataService.timeWorked.setEmployee(this.crewTimecardDataService.employees[1].Value);
			else
				this.crewTimecardDataService.timeWorked.setEmployee(null);
		}

		if (this.crewTimecardDataService.payPeriod.EnableCrews)
			this.filterByEmployeeMultiple();
		else
			this.filterByEmployee();
	}

	private refreshEmployeeList() {
		webix.delay(() => {
			let employeeDropdownList = [];
			let multiselectEmployeesList = [];
			let usedEmployees = [];

			this.dataTable.eachRow((rowID) => {
				let rowValues = this.dataTable.getItem(rowID);
				let employee = null;
				let currentEmployee = rowValues.Employee;
				currentEmployee = currentEmployee.substr(0, currentEmployee.indexOf("@"));
				if (usedEmployees.indexOf(currentEmployee) == -1) {
					//get employee from employeeList
					let employee = null;
					this.unfilteredEmployeeList.every((unfilteredEmployee) => {
						if (unfilteredEmployee.Value == currentEmployee) {
							employee = unfilteredEmployee;
							return false;
						}
						return true;
					});
					if (employee == null) {
						employee = { Label: rowValues["Employee___@Value"], Value: currentEmployee };
					}

					employeeDropdownList.push(employee);
					usedEmployees.push(currentEmployee);
				}
			});
			employeeDropdownList.sort(this.employeeDropdownSort);
			if (this.crewTimecardDataService.payPeriod.EnableCrews)
				multiselectEmployeesList = _.cloneDeep(employeeDropdownList);
			employeeDropdownList.unshift({ Value: "all", Label: "All Employees" });
			this.crewTimecardDataService.employees = employeeDropdownList;
			this.crewTimecardDataService.multiSelectEmployees = multiselectEmployeesList;

		}, this.dataTable);
  }

  private filterByEmployee() {
		if (this.crewTimecardDataService.selectedEmployee == null || this.crewTimecardDataService.selectedEmployee == "all") {
			this.loadDataTable(this.rawData, false);
		}
		else {
			let tempData = [];
			if (this.rawData.TimecardData.Employee["@Value"] == null) {
				$.each(this.rawData.TimecardData.Employee, (key, val) => {
					if (val["@Value"] == this.crewTimecardDataService.selectedEmployee) {
						tempData.push(val);
					}
				});
			}
			else {
				if (this.rawData.TimecardData.Employee["@Value"] == this.crewTimecardDataService.selectedEmployee) {
					tempData.push(this.rawData.TimecardData.Employee);
				}
			}

			let filteredData = _.cloneDeep(this.rawData);
			filteredData.TimecardData.Employee = tempData;
			this.loadDataTable(filteredData, true);
		}
  }

	private filterByEmployeeMultiple() {
		//get selected employees from list
		if (this.crewTimecardDataService.selectedEmployees.length == 0 || this.crewTimecardDataService.selectedEmployees.length == this.crewTimecardDataService.multiSelectEmployees.length) {
			this.loadDataTable(this.rawData, false);
		}
		else {
			let tempData = [];
			if (Array.isArray(this.rawData.TimecardData.Employee)) {
				$.each(this.rawData.TimecardData.Employee, (key, val) => {
					if (this.crewTimecardDataService.selectedEmployees.map((x) => { return x.Value; }).indexOf(val["@Value"]) > -1) {
						tempData.push(val);
					}
				});
				let filteredData = _.cloneDeep(this.rawData);
				filteredData.TimecardData.Employee = tempData;
				this.loadDataTable(filteredData, true);
			}
			else {
				this.loadDataTable(this.rawData, false);
			}
		}
	}

	private filterByType() {
		//filter rows
		var filteredRows = [], filteredColumns = [], filteredRowProperties = [];;
		this.gridData.rows.forEach((row) => {
			if (row.Type != null && row.Type != "") {
				var index = row.Type.indexOf("@");
				var typeValue = index > -1 ? row.Type.substr(0, index) : row.Type;
				if (typeValue == this.crewTimecardDataService.type)
					filteredRows.push(row);
			}
    })

		//filter columns
		this.gridData.columns.forEach((column) => {
			if (this.gridData.rowPropertyNames.indexOf(column.id) == -1) {
				filteredColumns.push(column);
			}
			else if (this.sharedColumnInfo[column.id] != null && column.id != "Type") {
				var colLineType = this.sharedColumnInfo[column.id].LineType;
				if (this.crewTimecardDataService.type == "J") {
					if (colLineType == "J" || colLineType == "A" || colLineType == "F" || colLineType == "T") {
						filteredColumns.push(column);
						filteredRowProperties.push(column.id);
					}
				}
				else if (this.crewTimecardDataService.type == "S") {
					if (colLineType == "S" || colLineType == "A" || colLineType == "T") {
						filteredColumns.push(column);
						filteredRowProperties.push(column.id);
					}
				}
				else if (this.crewTimecardDataService.type == "M") {
					if (colLineType == "M" || colLineType == "A" || colLineType == "F") {
						filteredColumns.push(column);
						filteredRowProperties.push(column.id);
					}
				}
			}
    })

		this.gridData.rows = filteredRows;
		this.gridData.columns = filteredColumns;
		this.gridData.rowPropertyNames = filteredRowProperties;
  }

  private loadDataTable(data, isFiltered) {
		//if the data is filtered, call GetGridData to get a parsed version of the unfiltered grid data
		let rawGridData = this.crewTimecardManagerService.getGridData(this.rawData, this.sharedColumnInfo, this.crewTimecardDataService.payPeriod);
		this.rawRows = rawGridData.rows;
		if (isFiltered && this.crewTimecardDataService.usageMode != "approval") {
			this.gridData = this.crewTimecardManagerService.getGridData(data, this.sharedColumnInfo, this.crewTimecardDataService.payPeriod);
		}
		else {
			this.gridData = this.crewTimecardManagerService.getGridData(data, this.sharedColumnInfo, this.crewTimecardDataService.payPeriod);
		}

		//if timeworked is enabled, calculate totals
		if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled && this.crewTimecardDataService.usageMode == "crewtimecard" ) {
			this.calculateTimecardTotals();
		}

		this.firstRowCopy = _.cloneDeep(this.gridData.rows[0]);

		//filter grid data columns and rows by type
		if (this.gridData.rowPropertyNames.indexOf("Type") > -1 && this.crewTimecardDataService.type != "all")
			this.filterByType();

		//ApprovalTODO - generate filter lists for job approval

		this.columnRules = {}
		//create validation and sorting rules
		$.each(this.gridData.columns, (key, val) => {
			let metadataName = val.id.substr(val.id.lastIndexOf("@") + 1);
			if (metadataName in this.sharedColumnInfo) {
				if (this.sharedColumnInfo[metadataName].IsCombo == 1) {
					val.sort = this.dropdownSort(metadataName);
				}
				else {
					if (metadataName == "udSort") {
						this.columnRules[val.id] = this.isInteger;
						val.sort = "int";
					}
					else {
						switch (this.sharedColumnInfo[metadataName].ValidationDataType) {
							case "int":
								this.columnRules[val.id] = this.isInteger;
								val.sort = "int";
								break;
							case "numeric":
								this.columnRules[val.id] = this.isNumber;
								val.sort = "int";
								break;
							case "varchar":
								val.sort = "string";
								break;
						}
					}

				}
			}
		});


		//add id to each row
		$.each(this.gridData.rows, (key, val) => {
			$.each(val, (rowKey, rowVal) => {
				if (this.rowKeysToIgnore.indexOf(rowKey) == -1 && rowVal.indexOf("@row_") != -1) {
					this.gridData.rows[key][rowKey] = rowVal + this.crewTimecardDataService.newRowID;
				}
			});
			val.id = this.crewTimecardDataService.newRowID;
			this.crewTimecardDataService.newRowID++;
		});

    //add editors
		this.addEditors();

		//Note - unfiltered rows is for Job Approval
		//unfilteredRows = angular.copy(gridData.rows);

		//set udSort
		if (this.columnExists("udSort")) {
			for (let i = 0; i < this.rawRows.length; i++) {
				let sortValue = this.rawRows[i]["udSort"];
				if (sortValue != null && sortValue != "" && sortValue > this.largestSortID) {
					this.largestSortID = sortValue;
				}
			}
		}

		//ApprovalTODO - count pending/rejected rows then perform approval filter

		//set webix datatable split settings
		this.leftSplit = this.getDataTableSplit();

		//ApprovalTODO - set subview grid

		//calculate height
		if (this.usageMode == "approval") {
			this.height = Math.max($(document).height() - $("#crewActionBar").height() - 210, 300);
		}
		//handle sizing adjustment for time worked            
		else {
			this.height = Math.max($(document).height() - $("#crewActionBar").height() - 170 - (this.crewTimecardDataService.isSubmitted ? 80 : 0), 300);
		}

		this.initWebixGrid();
	}

	private getDataTableSplit() {
		let leftSplit = 0;
		if (this.mobileMode && this.crewTimecardDataService.usageMode != "approval" && this.crewTimecardDataService.template.StickyColumnCount != 0) {
			leftSplit = 1;
		}
		else if (this.mobileMode && this.crewTimecardDataService.usageMode == "approval") {
			leftSplit = 2;
		}
		else if (this.crewTimecardDataService.usageMode == "approval") {
			leftSplit = this.crewTimecardDataService.payPeriod != null && this.crewTimecardDataService.payPeriod.StickyJobApprovalCount != null ? this.crewTimecardDataService.payPeriod.StickyJobApprovalCount : this.gridData.rowPropertyNames.length;
		}
		else {
			leftSplit = this.crewTimecardDataService.template != null && this.crewTimecardDataService.template.StickyColumnCount != null ? this.crewTimecardDataService.template.StickyColumnCount : this.gridData.rowPropertyNames.length;
		}
		return leftSplit;
  }

	//Grid init functions
	private initWebixGrid() {
		if (this.dataTable != null) {
			this.dataTable.destructor();
			this.dataTable = null;
		}

		//TODO - incomplete properties to convert
		//rules: tooltip, on, ready
		//on is used for subview creation for approval
		//not sure if tooltip is used or necessary
    this.dataTable = <webix.ui.datatable> webix.ui({
      container: this.crewTimecardID,
      id: this.crewTimecardID,
      view: "datatable",
      columns: this.gridData.columns,
      data: this.gridData.rows,
			resizeColumn: true,
			height: this.height,
			editable: true,
			footer: true,
			math: true,
			leftSplit: this.leftSplit,
			rules: this.columnRules,
			scheme: {
				$change: this.sumHours
			},
			type: {
				rcheckbox: function (obj, common, value, config) {
					var checked = (value == config.checkValue) ? 'checked="true"' : '';
					return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
				}
			},
			onClick: {
				"approvebtn": (e, id, trg) => this.approveRow(e, id, trg),
				"delbtn": (e, id, trg) => this.deleteRow(e, id, trg),
				"splitbtn": (e, id, trg) => this.splitRow(e, id, trg),
				"copybtn": (e, id, trg) => this.copyRow(e, id, trg)
      }
		});
		this.crewTimecardDataService.dataTable = this.dataTable;
		this.initRows();
		this.applyTableReadOnly();
		this.attachWebixEvents();
		this.attachWebixKeyboardOverrides();
		this.dataTable.refresh();
    this.dataTable.resize();
	}

	sumHours(items) {

		let total: number = 0;
		let earnCodeIndex = _this.gridData.columnPropertyNames.indexOf("EarnCode");
		let payTypeIndex = _this.gridData.columnPropertyNames.indexOf("PayType");

		if (earnCodeIndex > -1 || payTypeIndex > -1) {
			//Check earncode or paytype depending on type
			if (items.Type == "S") {
				$.each(items, (key: string, val) => {
					if (key.substr(key.indexOf("@") + 1) == "Hours") {
						let keyParts = key.split("___");
						let payType = keyParts[payTypeIndex];
						if (_this.amountPayTypes.indexOf(payType) == -1) {
							if (val != "" && !isNaN(val)) {
								total += parseFloat(val);
							}
						}

					}
				});
			}
			else {
				$.each(items, (key: string, val) => {
					if (key.substr(key.indexOf("@") + 1) == "Hours") {
						let keyParts = key.split("___");
						let earnCode = keyParts[earnCodeIndex];
						if (_this.amountEarnCodes.indexOf(earnCode) == -1) {
							if (val != "" && !isNaN(val)) {
								total += parseFloat(val);
							}
						}

					}
				});
			}

		}
		else {
			$.each(items, (key: string, val) => {
				if (key.substr(key.indexOf("@") + 1) == "Hours") {
					if (val != "" && !isNaN(val)) {
						total += parseFloat(val);
					}
				}
			});
		}
		items["Sub Total"] = total.toFixed(2);
	}

	//creates custom webix datafilters and functions as necessary
	private customizeWebix() {
		(webix.ui.datafilter as any).summFixedColumn = webix.extend({
			refresh: (master, node, value) => {
				let result = 0;
				let num = 0;
				let expenses = 0;
				master.mapCells(null, value.columnId, null, 1, (value, row_id) => {
					let valueCopy = value;
					if (this.dataTable != null && this.dataTable.getItem(row_id) != null) {
						let row = this.dataTable.getItem(row_id);
						let exclude = false;
						if (row.Type != null && row.Type != "") {
							let index = row.Type.indexOf("@");
							let typeValue = index > -1 ? row.Type.substr(0, index) : row.Type;
							if (typeValue == "S") {
								if (row.SMPayType != null && row.SMPayType != "" && row.SMPayType != "null") {
									let payType = row.SMPayType.substr(0, row.SMPayType.indexOf("@"));
									if (this.amountPayTypes.indexOf(payType) > -1) {
										exclude = true;
									}
								}
							}
							else {
								if (row.EarnCode != null && row.EarnCode != "" && row.EarnCode != "null") {
									let earnCode = row.EarnCode.substr(0, row.EarnCode.indexOf("@"));
									if (this.amountEarnCodes.indexOf(earnCode) > -1) {
										exclude = true;
									}
								}
							}

						}
						else {
							if (row.EarnCode != null && row.EarnCode != "" && row.EarnCode != "null") {
								let earnCode = row.EarnCode.substr(0, row.EarnCode.indexOf("@"));
								if (this.amountEarnCodes.indexOf(earnCode) > -1) {
									exclude = true;
								}
							}
						}
						if (!exclude) {
							valueCopy = valueCopy * 1;
							if (!isNaN(valueCopy))
								result += valueCopy;

						}
						else {
							if (!isNaN(valueCopy)) {
								expenses += parseFloat(valueCopy);
							}
						}
						return value;

					}
					else {
						valueCopy = value * 1;
						if (!isNaN(valueCopy))
							result += valueCopy;
						return value;
					}
				});
				this.crewTimecardDataService.expenses = expenses;
				node.firstChild.innerHTML = result.toFixed(2);
			}
		}, webix.ui.datafilter.summColumn);
	}

	private addEditors() {
		let dateFormat = webix.Date.dateToStr("%m/%d/%y", false);
		let earnCodeIndex = this.gridData.columnPropertyNames.indexOf("EarnCode");
		let isEarnCodeColumn = earnCodeIndex > -1;
		let payTypeIndex = this.gridData.columnPropertyNames.indexOf("PayType");
		let isPayTypeColumn = payTypeIndex > -1;

		$.each(this.gridData.columns, (loopGridColumnIndex, loopGridColumn) => {
			let columnName = loopGridColumn.id.substr(loopGridColumn.id.indexOf("@") + 1);

			if (this.sharedColumnInfo[columnName] != null && (this.crewTimecardDataService.usageMode != "approval" || columnName != "Employee")) {
				if (this.sharedColumnInfo[columnName].IsCombo === 1) {

					if (this.mobileMode)
						loopGridColumn.editor = 'popupWindowCombo';
					else
						loopGridColumn.editor = 'combo';
					loopGridColumn.template = function (obj) {
						let value = "";
						if (_this.columnOptions[loopGridColumn.id].getItem(obj[loopGridColumn.id]) != null) {
							value = _this.columnOptions[loopGridColumn.id].getItem(obj[loopGridColumn.id]).value;
						}
						if (_this.crewTimecardDataService.usageMode == "approval" && _this.sharedColumnInfo[columnName].ApprovalVisibilityModeID == 2)
							return value;
						else {
							if (columnName != "Employee" && columnName != "Type" && (_this.sharedColumnInfo[columnName] == null || _this.sharedColumnInfo[columnName].ColumnVisibilityModeID == 2)) {
								return value;
							}
							else {
								return "<span class='webix_icon wxi-angle-down' style='float:left;line-height:34px;font-size:10px;'></span>" + value;
							}

						}

					}
					this.columnOptions[loopGridColumn.id] = new webix.DataCollection({});
					loopGridColumn.options = this.columnOptions[loopGridColumn.id];

					//insert initial options
					let tempOptions = [];
					$.each(this.gridData.rows, (key, val) => {
						let value = val[loopGridColumn.id + "___@Value"];
						let id = val[loopGridColumn.id];
						if (id != null) {
							let obj = { id: id, value: value, visible: true };
							if (loopGridColumn.id == "udKDSTrackerID" && value == "") {
								obj.value = "Standard Timecard";
							}
							if (this.containsObject(obj, tempOptions) == -1)
								tempOptions.push(obj);
						}
					});
					$.each(tempOptions, (key, val) => {
						this.columnOptions[loopGridColumn.id].add(val);
					});

					if (this.sharedColumnInfo[columnName].ColumnVisibilityModeID == 4) {
						loopGridColumn.suggest = {
							on: {
								onBeforeShow: function () {
									this.define("width", 300);
									this.resize();
								}
							},
							body: {
								dataFeed: function (value, valueObject) {
									let row = _this.dataTable.getItem(_this.currentCell.row);
									if (valueObject.value != null && valueObject.value.length > 2 && _this.currentCell != null) {

										let requestParams = _this.getRequestParams(_this.currentCell.column, row, false);
										requestParams.currentCell = _this.currentCell;
										requestParams.rowData.searchString = valueObject.value;
										this.load("valueLookupProxy->/Timecard/GetCellPossibleValues", (options) => { _this.lastUsedList = options }, requestParams);
									}
									else if (row[_this.currentCell.column + "___@Value"] != null && row[_this.currentCell.column + "___@Value"] != "") {
										let requestParams = _this.getRequestParams(_this.currentCell.column, row, false);
										requestParams.currentCell = _this.currentCell;
										requestParams.rowData.searchString = row[_this.currentCell.column + "___@Value"];
										this.parse([{ id: row[_this.currentCell.column], value: row[_this.currentCell.column + "___@Value"], visible: true }])
										this.load("valueLookupProxy->/Timecard/GetCellPossibleValues", (options) => { _this.lastUsedList = options }, requestParams);
									}
									else {
										this.parse([{ id: "null", value: "Type more to load options...", visible: true }]);
									}

								}
							}
						}
					}
					else {

						loopGridColumn.suggest = {
							filter: function (item, value) {

								if (item.value.toString().toLowerCase().replace(/ /g, '').indexOf(value.toLowerCase().replace(/ /g, '')) > -1 && item.visible == true)
									return true;
								return false;
							},
							fitMaster: _this.sharedColumnInfo[columnName].InputLength > 300,
							relative: "bottom"
						};
					}
				}
				//case for bYN
				else if (this.sharedColumnInfo[columnName].ValidationDataType == "bit") {
					loopGridColumn.editor = "checkbox";
					loopGridColumn.checkValue = "Y";
					loopGridColumn.uncheckValue = "N";
					loopGridColumn.template = function (obj, common, value, config) {

						let emp = obj.Employee.substr(0, obj.Employee.indexOf("@"));
						if (obj.IsApproved == "1" ||
							obj.IsSubmitted == "1" ||
							obj.IsReadOnly == "1" ||
							(_this.employeeLockStatus[emp] != null && _this.employeeLockStatus[emp].IsLocked) ||
							_this.sharedColumnInfo[columnName].ColumnVisibilityModeID == 2 ||
							(_this.crewTimecardDataService.usageMode == "approval" && (obj.PendingStatus != "U" || _this.sharedColumnInfo[columnName].ApprovalVisibilityModeID == 2))) {
							return common.rcheckbox(obj, common, value, config);
						}
						else {
							return common.checkbox(obj, common, value, config);
						}
					};

				}
				else {
					if (columnName == "PostDate") {
						loopGridColumn.editor = 'date';
						loopGridColumn.map = "(date)#PostDate#"
						loopGridColumn.format = dateFormat;
						loopGridColumn.sort = "date";
					}
					else if (columnName == "StartTime") {
						loopGridColumn.editor = 'startTime';
					}
					else if (columnName == "StopTime") {
						loopGridColumn.editor = 'stopTime';
					}
					else if (columnName == "Hours") {
						loopGridColumn.editor = 'number';
						loopGridColumn.template = function (row) {

							if (row[loopGridColumn.id] != null) {
								if (row.Type != null && row.Type != "") {
									let type = row.Type.substr(0, row.Type.indexOf("@"));
									if (type == "S") {
										let payType;
										if (isPayTypeColumn) {
											let columnValueParts = loopGridColumn.id.split("___");
											payType = columnValueParts[earnCodeIndex];
										}
										else {
											if (row.SMPayType != null && row.PayType != "" && row.SMPayType != "null") {
												payType = row.SMPayType.substr(0, row.SMPayType.indexOf("@"));
											}
											else {
												return row[loopGridColumn.id];
											}
										}
										if (_this.amountPayTypes.indexOf(payType) > -1) {
											return webix.i18n.priceFormat(row[loopGridColumn.id]);
										}
										else {
											return row[loopGridColumn.id];
										}
									}
									else {
										let earnCode;
										if (isEarnCodeColumn) {
											let columnValueParts = loopGridColumn.id.split("___");
											earnCode = columnValueParts[earnCodeIndex];
										}
										else {
											if (row.EarnCode != null && row.EarnCode != "" && row.EarnCode != "null") {
												earnCode = row.EarnCode.substr(0, row.EarnCode.indexOf("@"));
											}
											else {
												return row[loopGridColumn.id];
											}
										}

										if (_this.amountEarnCodes.indexOf(earnCode) > -1) {
											return webix.i18n.priceFormat(row[loopGridColumn.id]);
										}
										else {
											return row[loopGridColumn.id];
										}
									}
								}
								else {
									let earnCode;
									if (isEarnCodeColumn) {
										let columnValueParts = loopGridColumn.id.split("___");
										earnCode = columnValueParts[earnCodeIndex];
									}
									else {
										if (row.EarnCode != null && row.EarnCode != "" && row.EarnCode != "null") {
											earnCode = row.EarnCode.substr(0, row.EarnCode.indexOf("@"));
										}
										else {
											return row[loopGridColumn.id];
										}
									}

									if (_this.amountEarnCodes.indexOf(earnCode) > -1) {
										return webix.i18n.priceFormat(row[loopGridColumn.id]);
									}
									else {
										return row[loopGridColumn.id];
									}
								}
							}
							else {
								return "";
							}
							//check if type exists, else treat it as a "J" type

						}
					}
					else {
						loopGridColumn.editor = 'text';
					}
				}
			}

			else if (columnName == "udKDSTrackerID") {
				this.columnOptions[loopGridColumn.id] = new webix.DataCollection({});
				loopGridColumn.editor = 'combo';
				loopGridColumn.template = function (obj) {
					let value = "";
					if (_this.columnOptions[loopGridColumn.id].getItem(obj[loopGridColumn.id]) != null) {
						value = _this.columnOptions[loopGridColumn.id].getItem(obj[loopGridColumn.id]).value;
					}
					return value;
				}

				loopGridColumn.options = this.columnOptions[loopGridColumn.id];
				//insert initial options
				let tempOptions = [];
				$.each(this.gridData.rows, (key, val) => {
					let value = val[loopGridColumn.id + "___@Value"];
					let id = val[loopGridColumn.id];
					if (id != null) {
						let obj = { id: id, value: value, visible: true };
						if (this.containsObject(obj, tempOptions) == -1)
							tempOptions.push(obj);
					}
				});
				$.each(tempOptions, (key, val) => {
					this.columnOptions[loopGridColumn.id].add(val);
				});
				loopGridColumn.suggest = {
					filter: function (item, value) {
						if (item.value.toString().toLowerCase().indexOf(value.toLowerCase()) > -1 && item.visible == true)
							return true;
						return false;
					},
					fitMaster: this.sharedColumnInfo[columnName].InputLength > 300,
					relative: "bottom"
				};
			}

			else if (loopGridColumn.id == "Sub Total") {
				loopGridColumn.template = function (obj) {
					if (obj[loopGridColumn.id] != null) {
						if (!isEarnCodeColumn && obj.EarnCode != null && obj.EarnCode != "" && obj.EarnCode != "null") {
							let earnCode = obj.EarnCode.substr(0, obj.EarnCode.indexOf("@"));
							if (_this.amountEarnCodes.indexOf(earnCode) > -1) {
								return webix.i18n.priceFormat(obj[loopGridColumn.id]);
							}
							else {
								return obj[loopGridColumn.id];
							}
						}
						else {
							return obj[loopGridColumn.id];
						}

					}
					else {
						return "";
					}

				}
			}
			else if (columnName == "action") {
				loopGridColumn.editor = null;
			}
			else {
				loopGridColumn.editor = 'text';
			}
		});
	}

	private attachWebixEvents() {
		this.dataTable.attachEvent("onBeforeEditStart", (eventInfo) => this.beforeEditStart(eventInfo));
		this.dataTable.attachEvent("onAfterEditStart", (id) => this.afterEditStart(id));
		this.dataTable.attachEvent("onBeforeEditStop", (state, editor) => this.beforeEditStop(state,editor));
		this.dataTable.attachEvent("onAfterEditStop", (state, editor) => this.afterEditStop(state, editor));
		this.dataTable.attachEvent("onCheck", (id, column, state) => this.onCheck(id, column, state));
		this.dataTable.attachEvent("onHeaderClick", (id) => this.onHeaderClick(id));
		//TODO implement for approval
		//this.dataTable.attachEvent("onSubViewCreate", this.onSubViewCreate);

	}

	private attachWebixKeyboardOverrides() {
		//webix keyboard controls
		this.dataTable.attachEvent("onKeyPress", (code, e) => {
			if (!this.crewTimecardDataService.timecardSaving && !this.crewTimecardDataService.loadingValues) {
				if ((this.crewTimecardDataService.usageMode != "PR" && this.crewTimecardDataService.usageMode != "PREQ")) {
					//ctrl + `
					if (e.ctrlKey && code === 192) {
						if (!this.isReadOnlyGridTime)
							this.addTimecardRow(false);
					}
				}

				//tab controls
				if (code === 9) {
					e.preventDefault();
					//F = forward, B = back
					if (e.shiftKey)
						this.tabPressed = "B";
					else
						this.tabPressed = "F"
					let editor = this.dataTable.getEditor();
					this.nextEditor = editor;
					if (editor == null || editor == 0) {

						if (this.lastEditedCell != null && this.lastEditedCell != 0 && !this.mobileMode) {
							webix.delay(() => {
								this.dataTable.editNext();
							}, this.dataTable);
						}
					}
					else if (editor.config.editor == "combo") {
						let value = editor.getPopup().getBody().getSelectedId();
						if (this.sharedColumnInfo[editor.config.id] == null) {
							if (value == null || value == "") {
								value = editor.getPopup().getBody().getFirstId();
							}
							editor.setValue(value);
						}
						else {
							if (value != "") {
								value = editor.getPopup().getBody().getFirstId();
								editor.setValue(value);
							}

						}

					}
				}

				//Arrow down
				if (code === 40) {
					e.preventDefault();
					let last = this.dataTable.getLastId();
					let editor = this.dataTable.getEditor();
					if (this.gridData.rowPropertyNames.indexOf(editor.column) == -1 && editor != null && editor.config.editor != "combo") {
						let newRow = this.dataTable.getNextId(editor.row, 1);
						if (newRow != undefined) {
							this.dataTable.editCell(newRow, editor.column, false, true);
						}
					}
				}

				//Arrow up
				if (code === 38) {
					e.preventDefault();
					let first = this.dataTable.getFirstId();
					let editor = this.dataTable.getEditor();
					if (this.gridData.rowPropertyNames.indexOf(editor.column) == -1 && editor != null && editor.config.editor != "combo") {
						let newRow = this.dataTable.getPrevId(editor.row, 1);
						if (newRow != undefined) {
							this.dataTable.editCell(newRow, editor.column, false, true);
						}
					}
				}

				//Enter key
				if (code === 13) {
					this.nextEditor = this.dataTable.getEditor();
					webix.delay(() => {
						this.dataTable.editNext();
					}, this.dataTable);

				}
			}
		});
  }

	//Counts subimitted rows and adds initial readonly CSS
	private initRows() {
		let previousEmployee: any = null;
		this.crewTimecardDataService.rowCount = this.dataTable.count();
		if (this.crewTimecardDataService.usageMode != "approval") {
			this.dataTable.eachRow((rowID) => {
				let row = this.dataTable.getItem(rowID);
				let isEmployeeRow = $.inArray("Employee", this.gridData.rowPropertyNames) != -1;
				let currentEmployee = row.Employee;
				currentEmployee = currentEmployee.substr(0, currentEmployee.indexOf("@"));
				if (row.IsApproved == "1" && row.IsReadOnly != "1")
					this.crewTimecardDataService.approvedRows++;
				if (row.IsSubmitted != "1")
					this.crewTimecardDataService.unsubmittedRows++;
				else {
					if (this.employeesToExclude.indexOf(currentEmployee) == -1) {
						this.employeesToExclude.push(currentEmployee);
					}
				}
				if (row.IsSubmitted == "1" && row.IsApproved == "0" && row.IsReadOnly != "1")
					this.crewTimecardDataService.unapprovedRows++;
				//apply readonly css if necessary
				this.dataTable.addCellCss(rowID, "Sub Total", "cellReadOnly");
				if (row.IsReadOnly == "1") {
					$.each(this.gridData.columns, (key, column) => {
						this.dataTable.addCellCss(rowID, column.id, "cellReadOnly");
					});
				}
				else {
					//hide approve button if Employee is not a row group or if the current employee is the same as the previous row.
					let employee = row.Employee;
					employee = employee.substr(0, employee.indexOf("@"));
					//make type read only on existing lines
					$.each(this.gridData.columns, (key, column) => {
						if (column.id == "Type") {
							this.dataTable.addCellCss(rowID, column.id, "cellReadOnly");
						}
					});

					if (employee != null) {
						if (row.IsSubmitted == "1" || (this.employeeLockStatus[employee] != null && this.employeeLockStatus[employee].IsLocked)) {
							$.each(this.gridData.columns, (key, column) => {
								if (column.id != "action")
									this.dataTable.addCellCss(rowID, column.id, "cellReadOnly");
							});
							//279351: allow hideCell only if it not Field ticket screen. Field ticket screen doesn't contain Approve button 
							if (!(this.crewTimecardDataService.usageMode == "PR" || this.crewTimecardDataService.usageMode == "PREQ") &&
								(!isEmployeeRow || currentEmployee == previousEmployee || row.IsApproved == "1" ||
									(this.employeeLockStatus[employee] != null && this.employeeLockStatus[employee].IsLocked && row.IsSubmitted != "1"))) {
								this.dataTable.addCellCss(rowID, "action", "hideCell");
							}
						}
					}
				}
				previousEmployee = row.Employee;
				previousEmployee = previousEmployee.substr(0, previousEmployee.indexOf("@"));
			});

			//count the number of unsubmitted rows in raw data for clone check
			let totalSubmittedRows = 0;
			this.rawRows.forEach((row) => {
				if (row.IsSubmitted == "1")
					totalSubmittedRows++;
			})
			this.crewTimecardDataService.totalSubmittedRows = totalSubmittedRows;

			//set time worked read only based on unsubmitted rows
			if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled) {
				this.crewTimecardDataService.timeWorked.setReadOnly(this.crewTimecardDataService.unsubmittedRows < this.crewTimecardDataService.rowCount);
			}
    }
	}

	private applyTableReadOnly() {
		let typeExists = this.gridData.rowPropertyNames.indexOf("Type") > -1;
		let earnPayExists = this.gridData.rowPropertyNames.indexOf("EarnCode") > -1 || this.gridData.rowPropertyNames.indexOf("PayType") > -1;
		this.dataTable.eachRow((rowID) => {
			let row = this.dataTable.getItem(rowID);
			if (typeExists || row["Type___@Value"] == "S") {
				this.applyLineTypeCSS(rowID);
			}
			if (earnPayExists) {
				this.applyAmountCSS(rowID);
			}

		});
  }

	//Webix event handlers
	//Note - use _this instead of this in the event handlers as the scope of the handlers is changed
	private beforeEditStart(eventInfo) {
		let nextCol, nextRow;
		if (_this.isReadOnlyGridTime || _this.crewTimecardDataService.readOnlyGrid)
			return false;
		let editor = _this.dataTable.getEditor();
		let resolvedColumnName = eventInfo.column.substr(eventInfo.column.indexOf("@") + 1);
		if (_this.sharedColumnInfo[eventInfo.column] != null && _this.sharedColumnInfo[eventInfo.column].ValidationDataType == "bit") {
			if (_this.tabPressed == "F") {
				nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) + 1);
			}
			else if (_this.tabPressed == "B") {
				nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) - 1);
			}
			if (nextCol) {
				_this.dataTable.editCell(eventInfo.row, nextCol, false, true);
			}
			return false;
		}
		let row = _this.dataTable.getItem(eventInfo.row);
		//disallow type change if row is not new
		if (eventInfo.column == "Type" && !row.isNewRow) {
			if (_this.tabPressed == "F") {
				nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) + 1);
			}
			else if (_this.tabPressed == "B") {
				nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) - 1);
			}
			if (nextCol) {
				_this.dataTable.editCell(eventInfo.row, nextCol, false, true);
			}
			return false;
		}
		//disallow editing if certain fields on an amount row
		if (eventInfo.column.indexOf("@StartTime") > -1 || eventInfo.column.indexOf("@StopTime") > -1 || eventInfo.column.indexOf("@BreakHours") > -1) {
			if (_this.isAmountRow(eventInfo.row)) {
				return false;
			}
		}
		let employee = row.Employee;
		employee = employee.substr(0, employee.indexOf("@"));
		//Note - JobPhaseCombined is hardcoded to be read only
		if (_this.crewTimecardDataService.usageMode == "approval") {
			if (((eventInfo.column.indexOf("@Hours") == -1 && eventInfo.column.indexOf("@UsageUnits") == -1)) &&
				(_this.sharedColumnInfo[resolvedColumnName] == null || _this.sharedColumnInfo[resolvedColumnName].ApprovalVisibilityModeID == 2 || resolvedColumnName == "JobPhaseCombined") || row.IsRowAggregate) {
				return false;
			}
			else if (((eventInfo.column.indexOf("@Hours") > -1) && (_this.sharedColumnInfo["Hours"].ApprovalVisibilityModeID == 2 || row.IsRowAggregate))) {
				return false;
			}
			else if ((eventInfo.column.indexOf("@UsageUnits") > -1) && (_this.sharedColumnInfo["UsageUnits"].ApprovalVisibilityModeID == 2 || row.IsRowAggregate)) {
				return false;
			}
			//#316534: For Locked, don't allow to edit
			if (row.IsLocked == '1')
				return false;
		}
		else {
			if (eventInfo.column != "Employee" && eventInfo.column != "Type" && (_this.sharedColumnInfo[eventInfo.column] != null && _this.sharedColumnInfo[eventInfo.column].ColumnVisibilityModeID == 2)) {
				return false;
			}
		}
		if (!_this.crewTimecardDataService.payPeriod.EnableCrews) {
			if (_this.crewTimecardDataService.selectedEmployee != null && _this.crewTimecardDataService.selectedEmployee != "all" && eventInfo.column == "Employee")
				return false;
		}

		if (_this.dependentQueue.length > 0) {
			return false;
		}
		//read only cell
		if (row.IsReadOnly == "1" || row.IsSubmitted == "1" || (_this.employeeLockStatus[employee] != null && _this.employeeLockStatus[employee].IsLocked)) {
			//279351: Allow edit on submitted record when the config is true for Field Ticket
			if (!((_this.crewTimecardDataService.usageMode == "PR" || _this.crewTimecardDataService.usageMode == "PREQ") && row.IsApproved == "0") || _this.portalSettings.DTREmpEquReadOnlyOverride.ConfigValue == 0)
				return false;
		}
		if (_this.crewTimecardDataService.usageMode == "approval" && row.PendingStatus != "U")
			return false;
		// return (do not allow editing) if _this cell is a "Grouping Cell" -- a treenode parent
		if (row.$parent != null && typeof (row.$parent) === "string" && row.$parent.length > 0 && row.$parent === eventInfo.row) {
			return false;
		}
		let isCellReferringToRowProperty = $.inArray(eventInfo.column, _this.gridData.rowPropertyNames) !== -1;
		let column = _this.gridData.getColumnByName(eventInfo.column);
		//allow edit if the column is the delete column
		if (column.id == "action") {
			_this.dataTable.editNext();
			_this.nextEditor = null;
			return true;
		}
		if (!isCellReferringToRowProperty && _this.gridData.columnMap[eventInfo.column] == null) return false;
		let columnName = isCellReferringToRowProperty ? eventInfo.column : _this.gridData.columnMap[eventInfo.column].valuePropertyName.substr(1);
		//disable edit if column does not match with line type
		if (columnName != "Type" && row.Type != null && row.Type != "") {
			let rowLineType = row.Type.substr(0, row.Type.indexOf("@"));
			let colLineType = _this.sharedColumnInfo[columnName].LineType;
			if (rowLineType == "J") {
				if (colLineType != "J" && colLineType != "A" && colLineType != "F" && colLineType != "T") {
					if (_this.tabPressed == "F") {
						nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) + 1);
						if (nextCol == "Sub Total") {
							nextCol = _this.dataTable.columnId(0);
							nextRow = _this.dataTable.getNextId(eventInfo.row, 1)
						}
					}
					else if (_this.tabPressed == "B") {
						nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) - 1);
					}
					if (nextCol) {
						if (nextRow)
							_this.dataTable.editCell(nextRow, nextCol, false, true);
						else
							_this.dataTable.editCell(eventInfo.row, nextCol, false, true);
					}
					return false;
				}

			}
			else if (rowLineType == "S") {
				if ((colLineType != "S" && colLineType != "A" && colLineType != "T") || columnName == "Job") {
					if (_this.tabPressed == "F") {
						nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) + 1);
						if (nextCol == "Sub Total") {
							nextCol = _this.dataTable.columnId(0);
							nextRow = _this.dataTable.getNextId(eventInfo.row, 1)
						}
					}
					else if (_this.tabPressed == "B") {
						nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) - 1);
					}
					if (nextCol) {
						if (nextRow)
							_this.dataTable.editCell(nextRow, nextCol, false, true);
						else
							_this.dataTable.editCell(eventInfo.row, nextCol, false, true);
					}
					return false;
				}
			}
			else if (rowLineType == "M") {
				if (colLineType != "M" && colLineType != "A" && colLineType != "F") {
					if (_this.tabPressed == "F") {
						nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) + 1);
						if (nextCol == "Sub Total") {
							nextCol = _this.dataTable.columnId(0);
							nextRow = _this.dataTable.getNextId(eventInfo.row, 1)
						}
					}
					else if (_this.tabPressed == "B") {
						nextCol = _this.dataTable.columnId(_this.dataTable.getColumnIndex(eventInfo.column) - 1);
					}
					if (nextCol) {
						if (nextRow)
							_this.dataTable.editCell(nextRow, nextCol, false, true);
						else
							_this.dataTable.editCell(eventInfo.row, nextCol, false, true);
					}
					return false;
				}
			}
		}
		if (_this.sharedColumnInfo[columnName].IsCombo !== 1) {
			return true;
		}
		_this.tabPressed = null;
		if (columnName == "Employee" && _this.employeeListBound && _this.sharedColumnInfo[eventInfo.column].ColumnVisibilityModeID != 4) {
			if (row.id != _this.lastRequestedRow)
				_this.bindPossibleValues(_this.employeeList, false, "Employee", row);
			else
				return true;
		}
		else if (_this.sharedColumnInfo[eventInfo.column].ColumnVisibilityModeID == 4) {
			return true;
		}
		else {
			//check if cache value exists, if not the cell has not been loaded yet
			if (_this.lookupValuesCache[row.id] != null) {
				if (_this.lookupValuesCache[row.id][columnName] != null) {
					//put cache binding logic here
					if (row.id != _this.lastRequestedRow)
						_this.bindPossibleValues(_this.lookupValuesCache[row.id][columnName], false, columnName, row);
				}
				else {
					_this.lookupValuesCache[row.id] = {};
					return _this.getCellValues(columnName, row, false);
				}
			}
			else {
				_this.lookupValuesCache[row.id] = {};
				return _this.getCellValues(columnName, row, false);
			}
		}
	}

	private afterEditStart(id) {
		_this.currentCell = id;
		let state = {old: null, value: null};
		let editor = _this.dataTable.getEditor();
		this.lastEditedCell = editor;
		state.old = editor.getValue();
		let row = _this.dataTable.getItem(id.row);
		_this.lastEditedCell = editor;
		if (editor.config.editor == "popupWindowCombo") {
			let requestParams = null;
			if (_this.sharedColumnInfo[editor.column].ColumnVisibilityModeID == 4) {
				requestParams = _this.getRequestParams(_this.currentCell.column, row, false);
				requestParams.currentCell = _this.currentCell;
			}
			let options = _this.columnOptions[id.column].serialize();
			options = options.filter(function (obj) {
				if (obj.visible && obj.value != "" && obj.value != "null")
					return true;
				return false;
			});

			let modalRef = _this.ngbmodalService.open(EditCellValueModalComponent);
			modalRef.componentInstance.options = options;
			modalRef.componentInstance.column = id.column;
			modalRef.componentInstance.mode = _this.sharedColumnInfo[editor.column].ColumnVisibilityModeID == 4 ? "super" : "normal";
			modalRef.componentInstance.requestParams = requestParams;

			modalRef.result.then((result: any) => {
				if (result != null && result.id != null && result.id != state.old) {
					if (result.id != "null" && _this.sharedColumnInfo[editor.column].ColumnVisibilityModeID == 4 && _this.columnOptions[editor.column].getItem(result.id) == null) {
						_this.columnOptions[editor.column].add({ id: result.id, value: result.value, visible: false });
					}
					row[id.column] = result.id;
					state.value = result.id;
					_this.valueChanged(state, editor);
				}
				_this.dataTable.refresh();
			}, () => {
				//dismissed
				_this.dataTable.refresh();
				_this.dataTable.editStop();
			});
		}
		else {
			let popup: any = $$(this.dataTable.getEditor().config.suggest);
			if (popup != null)
				popup.getList().filter("visible", true)
		}
	}

	private beforeEditStop(state, editor) {
		let row = _this.dataTable.getItem(editor.row);
		let colPrefix = editor.column.substr(0, editor.column.indexOf("@"));
		let startColName = colPrefix + "@StartTime";
		let stopColName = colPrefix + "@StopTime";
		if (state.value != state.old) {
			if (editor.column.indexOf("StartTime") != -1 && state.value != null && state.value != "") {
				let value = _this.timeParserService.parseStartStop(state.value, "StartTime", true);
				if (value != "Invalid Time") {
					state.value = value;
					if (row[stopColName] != null && row[stopColName] != "") {
						_this.calculateHours(row, colPrefix, true, false, false, state.value);
					}
				}
				else {
					this.crewTimecardDataService.alertType = "danger";
					this.crewTimecardDataService.alertMsg = "Invalid time entered: \"" + state.value + "\"";
				}
				
			}
			else if (editor.column.indexOf("StopTime") != -1 && state.value != null && state.value != "") {
				let value = _this.timeParserService.parseStartStop(state.value, "StopTime", true);
				if (value != "Invalid Time") {
					state.value = value
					if (row[startColName] != null && row[startColName] != "") {
						_this.calculateHours(row, colPrefix, false, true, false, state.value);
					}
				}
				else {
					this.crewTimecardDataService.alertType = "danger";
					this.crewTimecardDataService.alertMsg = "Invalid time entered: \"" + state.value + "\"";
				}
			}
			else if (editor.column.indexOf("BreakHours") != -1) {
				if (row[startColName] != null && row[startColName] != "") {
					_this.calculateHours(row, colPrefix, false, false, true, state.value);
				}
			}
		}
	}

	private afterEditStop(state, editor) {
		if (state.value != state.old) {
			if (this.columnOptions[editor.column] != null && this.columnOptions[editor.column].getItem(state.value) == null && this.lastUsedList != null) {
				for (var i = 0; i < this.lastUsedList.length; i++) {
					if (this.lastUsedList[i].id == state.value) {
						this.columnOptions[editor.column].add({ id: state.value, value: this.lastUsedList[i].value });
					}
				}
				//columnOptions[editor.column].add(id: state)
			};
			this.valueChanged(state, editor);
		}
	}

	private onCheck(id, column, state) {
		this.valueChanged(state, { row: id, column: column });
	}

	private valueChanged(state, editor) {
		let row = this.dataTable.getItem(editor.row);
		//if amount row, clear certain fields
		if (editor.column == "EarnCode" || editor.column == "PayType") {
			if (this.isAmountRow(editor.row)) {
				this.gridData.columns.forEach((column) => {
					let columnName = column.id;
					if (columnName.indexOf("@StartTime") > -1 || columnName.indexOf("@StopTime") > -1 || columnName.indexOf("@BreakHours") > -1) {
						row[columnName] = "";
					}
				})
			}
		}
		if (editor.column == "PostDate" && row["PostDate"] != null && typeof row["PostDate"].getMonth == 'function') {
			let yyyy = row["PostDate"].getFullYear().toString();
			let mm = (row["PostDate"].getMonth() + 1).toString();
			let dd = row["PostDate"].getDate().toString();
			row["PostDate"] = yyyy + "/" + mm + "/" + dd;
		}
		this.crewTimecardDataService.unsavedChanges = true;

		//Process change of line type
		//remove cell css
		if (this.crewTimecardDataService.usageMode != "PR" && this.crewTimecardDataService.usageMode != "PREQ") {
			if (editor.column == "Employee") {
				this.refreshEmployeeList();
			}
			if (editor.column == "EarnCode" || editor.column == "PayType") {
				this.applyAmountCSS(row.id);
			}
			if (editor.column == "Type") {
				this.gridData.columns.forEach((val) => {
					if (val.id != "Sub Total")
						this.dataTable.removeCellCss(row.id, val.id, "cellReadOnly");
				});
				this.applyLineTypeCSS(row.id);
			}
			if (this.gridData.rowPropertyNames.indexOf(editor.column) != -1) {
				row.headerModified = true;

				//Do dependent stuff here
				if (editor.column == "Employee" || editor.column == "Type") {
					//EMPLOYEE REBIND LOGIC RIGHT HERE
					this.rebindingEmployee = true;
					let isTypeUsed = row.Type != null && row.Type != "" && row.Type.substr(0, row.Type.indexOf("@")) != "";
					let employeeDependentColumns = this.sharedColumnInfo["Employee"].DependentColumns != null ? this.sharedColumnInfo["Employee"].DependentColumns.split(",") : [];
					this.gridData.rowPropertyNames.forEach((rowProperty) => {
						if (rowProperty != "Employee" && this.sharedColumnInfo[rowProperty] != null && this.sharedColumnInfo[rowProperty].IsCombo == 1) {
							if (employeeDependentColumns.indexOf(rowProperty) > -1 && (!isTypeUsed || !this.isCellReadOnly(row, rowProperty))) {
								this.dependentQueue.push(rowProperty);
							}
						}
					});
				}
				else if (this.sharedColumnInfo[editor.column].DependentColumns != null && this.sharedColumnInfo[editor.column].DependentColumns != "") {
					let dependentColumns = this.sharedColumnInfo[editor.column].DependentColumns.split(",");
					dependentColumns.forEach((col) => {
						if (this.gridData.rowPropertyNames.indexOf(col) > -1) {
							let isTypeUsed = row.Type != null && row.Type != "" && row.Type.substr(0, row.Type.indexOf("@")) != "";
							if (!isTypeUsed || !this.isCellReadOnly(row, col)) {
								this.dependentQueue.push(col);
							}
						}
						if (col == "Equipment" && editor.column == "WO" && this.sharedColumnInfo["Equipment"].IsAutoSelectFirstValue)
							this.equipmentAutoSelectRebind = true;
					});

				}
				if (this.dependentQueue.length > 0) {
					this.getCellValues(this.dependentQueue[0], row, true);
				}
				else {
					if (this.rebindingEmployee) {
						let employee = "";
						if (row["Employee"] != null && row["Employee"] != "")
							employee = row["Employee"].substr(0, row["Employee"].indexOf("@"));
						this.rebindingEmployee = false;
						if (this.columnInfoByEmployee[employee] == null) {
							this.getEmployeeColumnInfo(employee, row.id, false, false);
						}
						else {
							this.bindDefaultValues(row.id);
						}
					}
				}
			}
		}
		else {
			if (this.gridData.rowPropertyNames.indexOf(editor.column) != -1) {
				row.headerModified = true;
			}
		}

		//save display value under ___@Value
		if (this.sharedColumnInfo[editor.column] != null && this.sharedColumnInfo[editor.column].IsCombo === 1) {
			let optionItem = this.columnOptions[editor.column].getItem(state.value);
			if (optionItem != null) {
				row[editor.column + "___@Value"] = optionItem.value;
			}
			else {
				row[editor.column + "___@Value"] = "";
			}
		}
	}

	private onHeaderClick(id) {
		if (this.dataTable.getColumnConfig(id.column).sort) {
			if (id.column != this.tableSort) {
				this.tableSort = id.column;
				this.tableReverse = false;
			}
			else {
				this.tableReverse = !this.tableReverse;
			}
			sessionStorage.setItem("CrewTableSort", this.tableSort);
			sessionStorage.setItem("CrewTableReverse", this.tableReverse.toString());
		}
  }

	//Webix button functions
	private deleteRow(e, id, trg) {
		this.dataTable.editStop();
		let row = this.dataTable.getItem(id);
		if (row.IsReadOnly != "1") {
			let promises = [];
			if (row.isNewRow != true) {
				let columnCollection = this.crewTimecardManagerService.getRow(id);
				let cellsToDelete = [];

				$.each(this.gridData.columnMap, (resolvedColumnName, columnMetadata) => {
					let keyID = this.crewTimecardManagerService.getColumnPropertyValue(columnCollection, resolvedColumnName, "@KeyID");
					cellsToDelete.push(keyID);
				});
				let cellIDString = cellsToDelete.join(",");
				let errors = 0;
				this.crewTimecardGridService.deleteTimecardRow(cellIDString).then((response: any) => {
					if (response.success) {
						this.dataTable.remove(id);
						this.crewTimecardDataService.rowCount = this.dataTable.count();
						this.crewTimecardDataService.unsubmittedRows--;

						//set time worked read only based on unsubmitted rows
						if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled) {
							this.crewTimecardDataService.timeWorked.setReadOnly(this.crewTimecardDataService.unsubmittedRows < this.crewTimecardDataService.rowCount);
						}
					}
				});
			}
			else {
				this.dataTable.remove(id);
				this.crewTimecardDataService.rowCount = this.dataTable.count();
				this.crewTimecardDataService.unsubmittedRows--;

				//set time worked read only based on unsubmitted rows
				if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled) {
					this.crewTimecardDataService.timeWorked.setReadOnly(this.crewTimecardDataService.unsubmittedRows < this.crewTimecardDataService.rowCount);
				}
			}
		}
		
		this.crewTimecardDataService.rowDeleted = true;
		return false;
  }

	private approveRow(e, id, trg) {
		let row = this.dataTable.getItem(id);
		//Handle approval logic here
		let promises = [];
		let keyID = this.crewTimecardManagerService.getRowID(id);

		if (keyID != null) {
			let modalMessage;
			let employee = row["Employee___@Value"];
			if (employee == null)
				modalMessage = "<p>Are you sure you want to approve this employee's timecard entries?</p>";
			else
				modalMessage = "<p>Are you sure you want to approve the timecard entries for " + employee + "?</p>";

			const initialState = {
				modalData: {
					modalTitle: "Approve Timecard Warning",
					modalMessage: modalMessage,
					modalAction: "Approve"
				}
			};

			let modalRef = this.bsModalService.show(WarningModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });

			modalRef.onHide.subscribe((response: any) => {
				var result = modalRef.content.userAction;
				if (result == "Approve") {
					this.crewTimecardDataService.timecardLoaded = false;
					this.crewTimecardGridService.approveCrewTimecard(this.crewTimecardDataService.template.CrewTemplateID, this.crewTimecardDataService.payPeriod.PRPCKeyID, keyID, moment().format("MM/DD/YYYY h:mm:ss a")).then((response) => {
						//TODO trigger approved timecards changed procedure
						this.loadTimecard("crewTimecardGrid");
					});
				}
			});
		}
	}

	//Note - this is called from the index component
	approveAllRows() {
		let promises = [];
		let previousEmployee = null;
		let i = 0;
		let keyIDs = '';
		this.dataTable.eachRow((rowID) => {
			let rowValues = this.dataTable.getItem(rowID);
			if (rowValues.IsSubmitted == "1" && rowValues.IsReadOnly != "1" && rowValues.IsApproved == "0") {
				let keyID = this.crewTimecardManagerService.getRowID(rowID);
				let currentEmployee = rowValues.Employee;
				currentEmployee = currentEmployee.substr(0, currentEmployee.indexOf("@"));
				if (keyID != null && previousEmployee != currentEmployee) {
					i++;
					keyIDs += keyID + ',';
					if (i % 50 == 0) {
						promises.push(
							this.crewTimecardGridService.approveCrewTimecard(this.crewTimecardDataService.template.CrewTemplateID, this.crewTimecardDataService.payPeriod.PRPCKeyID, null, moment().format("MM/DD/YYYY h:mm:ss a"), keyIDs)
						);
						keyIDs = '';
					}
				}
				previousEmployee = currentEmployee;
			}
		});

		if (keyIDs != '') {
			promises.push(this.crewTimecardGridService.approveCrewTimecard(this.crewTimecardDataService.template.CrewTemplateID, this.crewTimecardDataService.payPeriod.PRPCKeyID, null, moment().format("MM/DD/YYYY h:mm:ss a"), keyIDs));
		}

		forkJoin(promises).subscribe({
			complete: () => {
				this.loadTimecard(this.crewTimecardID);
				this.eventService.broadcast('approvedTimecardsChanged');			}
		});
	}

	private rejectRow(e, id, trg) {
		//TODO Approval Implement
	}

	private deleteZeroRow(e, id, trg) {
		//TODO Implement
	}

	private jobApprovalApprove(e, id, trg) {
		//TODO - Approval Implement
	}

	private jobApprovalUndo(e, id, trg) {
		//TODO - Approval Implement
	}

	private splitRow(e, id, trg) {
		//TODO - Approval Implement
	}

	//Note - renamed from "bulk employee add" to reduce confusion from the other bulk add
	private copyRow(e, id, trg) {
		let row = this.dataTable.getItem(id);
		if (this.crewTimecardDataService.payPeriod.EnableCrews && this.crewTimecardDataService.crewsList.length == 0) {
			this.getCrewsList(row);
		}
		else if (this.bulkEmployeeList.length == 0) {
			this.getBulkEmployeeList(row);
		}
		else {
			this.openCopyRowModal(row);
		}
	}


  //methods for getting additional data
	private getCellValues(columnName, row, isDependent) {
		//check if column is a super dropdown
		if (this.sharedColumnInfo[columnName].ColumnVisibilityModeID == 4 && (columnName != "Employee") && (columnName != "Equipment" || !this.equipmentAutoSelectRebind)) {
			if (columnName == "Equipment")
				this.equipmentAutoSelectRebind = false;
			let employee = "";
			if (row["Employee"] != null && row["Employee"] != "")
				employee = row["Employee"].substr(0, row["Employee"].indexOf("@"));

			if (isDependent) {
				//if column is a dependent, clear the field and rebind it's dependents
				row[columnName] = "";
				row[columnName + '___@Value'] = "";
				if (this.sharedColumnInfo[columnName].DependentColumns != null) {
					let dependentColumns = this.sharedColumnInfo[columnName].DependentColumns.split(",");
					$.each(dependentColumns, (colKey, col) => {
						if (this.gridData.rowPropertyNames.indexOf(col) > -1) {
							let isTypeUsed = row.Type != null && row.Type != "" && row.Type.substr(0, row.Type.indexOf("@")) != "";
							if (!isTypeUsed || !this.isCellReadOnly(row, col)) {
								this.dependentQueue.push(col);
							}
						}
					});
				}
			}
			this.dependentQueue.shift();
			if (this.dependentQueue.length > 0) {
				this.getCellValues(this.dependentQueue[0], row, true);
			}
			else {
				if (this.rebindingEmployee) {
					this.rebindingEmployee = false;
					if (this.columnInfoByEmployee[employee] == null) {
						this.getEmployeeColumnInfo(employee, row.id, null, null);
					}
					else {
						this.bindDefaultValues(row.id);
					}
				}
				else {
					this.crewTimecardDataService.loadingValues = false;
				}
			}
			return true;
		}
		let requestParams = this.getRequestParams(columnName, row, isDependent);
		let rowData = requestParams.rowData;
		let columnValuesString = requestParams.columnValuesString;
		if (!isDependent) {
			row[columnName + "___RowData"] = rowData;
		}
		this.crewTimecardDataService.loadingValues = true;
		//check if values exist in secondary cache
		if (this.cacheByColumnValue[columnValuesString] != null && this.cacheByColumnValue[columnValuesString][columnName] != null) {
			if (this.lookupValuesCache[row.id] != null) {
				this.lookupValuesCache[row.id][columnName] = this.cacheByColumnValue[columnValuesString][columnName];
			}
			else {
				this.lookupValuesCache[row.id] = {};
				this.lookupValuesCache[row.id][columnName] = this.cacheByColumnValue[columnValuesString][columnName];
			}
			this.bindPossibleValues(this.cacheByColumnValue[columnValuesString][columnName], isDependent, columnName, row);
		}
		else {
			//get lookup values from server
			this.crewTimecardGridService.getCellPossibleValues(rowData).then((response: any) => {
				let possibleValues = response.PossibleValues;
				for (let i = 0; i < possibleValues.length; i++) {
					possibleValues[i].Value = possibleValues[i].Value.replace(/(\r\n|\n|\r)/gm, "");
					possibleValues[i].PopUpLabel = possibleValues[i].Label.replace(/(\r\n|\n|\r)/gm, "");
					possibleValues[i].Label = this.escapeHtml(possibleValues[i].Label.replace(/(\r\n|\n|\r)/gm, ""));
				}
				if (columnName == "Employee" && !this.employeeListBound) {
					let callcount = 0;
					this.unfilteredEmployeeList = _.cloneDeep(possibleValues);
					for (let i = possibleValues.length - 1; i >= 0; i--) {
						if (this.employeesToExclude.indexOf(possibleValues[i].Value) > -1) {
							possibleValues.splice(i, 1);
							callcount++;
							if (callcount == this.employeesToExclude.length)
								break;
						}
					}
					this.employeeList = _.cloneDeep(possibleValues);
				}
				if (this.cacheByColumnValue[columnValuesString] != null) {
					this.cacheByColumnValue[columnValuesString][columnName] = possibleValues;
				}
				else {
					this.cacheByColumnValue[columnValuesString] = {};
					this.cacheByColumnValue[columnValuesString][columnName] = possibleValues;
				}
				if (this.lookupValuesCache[row.id] != null) {
					this.lookupValuesCache[row.id][columnName] = possibleValues;
				}
				else {
					this.lookupValuesCache[row.id] = {};
					this.lookupValuesCache[row.id][columnName] = possibleValues;
				}
				this.bindPossibleValues(possibleValues, isDependent, columnName, row);
			})
		}



		if (!isDependent)
			return false;
  }

	private getEmployeeColumnInfo(employee, rowID, rebindCurrent, addrow) {
		let employeeColumnInfo = {};
		if (this.columnInfoByEmployee[employee] == null) {
			this.crewTimecardGridService.getTimecardColumns(null, employee, this.crewTimecardDataService.payPeriod.PRCo, this.crewTimecardDataService.payPeriod.PRGroup, null, "C").then((response: any) => {
				$.each(response, (key, val) => {
					employeeColumnInfo[val.ColumnName] = val;
				});
				this.columnInfoByEmployee[employee] = employeeColumnInfo;
				if (rebindCurrent) {
					this.currentEmployeeColumns = this.columnInfoByEmployee[employee];
					if (addrow)
						this.addTimecardRow(true);
				}
				if (rowID != null) {
					this.bindDefaultValues(rowID);
				}
			});
		}
		else {
			if (rowID != null) {
				this.bindDefaultValues(rowID);
			}
		}
  }

  private getEmployeeColumns() {

	}

	private getEmployeeLockStatus() {
		this.crewTimecardGridService.getEmplLockStatus(this.crewTimecardDataService.payPeriod.HQBCKeyID, this.crewTimecardDataService.template.CrewTemplateID).then((response: any) => {
			this.crewTimecardDataService.lockedEmployees = [];;
			for (let  i = 0; i < response.length; i++) {
				this.employeeLockStatus[response[i].Employee] = response[i];
				this.employeesToExclude.push(response[i].Employee.toString());
				if (response[i].IsLocked)
					this.crewTimecardDataService.lockedEmployees.push(response[i]);
			}
		});
	}

	private getRequestParams(columnName, row, isDependent) {
		let rowPropArr = $.map(this.gridData.rowPropertyNames, (propName) => {
			return {
				propName: propName,
				propValue: this.crewTimecardManagerService.getRowValue(row, propName),
				isCombo: this.sharedColumnInfo[columnName] != null && this.sharedColumnInfo[columnName].IsCombo === 1,
				editable: true
			}
		});
		let valuePropPrefix = $.map(this.gridData.columnPropertyNames, (propName) => { return row[propName]; }).join('___') + '___';
		let columnValuesList = valuePropPrefix.split('___');
		let propsToRequest = rowPropArr
			.concat($.map(this.gridData.columnPropertyNames, (propName, propNameIndex) => {
				return {
					propName: propName,
					propValue: $.inArray(propName, this.gridData.rowPropertyNames) !== -1 ? null : columnValuesList[propNameIndex],
					editable: false,
					isCombo: false
				};
			}))
			.concat($.map(this.gridData.valuePropertyNames, (propName) => {
				let propNameAdjusted = propName.substr(1);
				let propValue = row[valuePropPrefix + '@' + propNameAdjusted];
				if (typeof propValue === "string") {
					propValue = propValue.substr(0, propValue.indexOf("@"));
				}
				return {
					propName: propNameAdjusted,
					propValue: propValue,
					editable: true,
					isCombo: this.sharedColumnInfo[propNameAdjusted].IsCombo === 1
				}
			}));
		let columnValues = $.map(propsToRequest, (columnObj, oblumnObjIndex) => {
			return {
				ColumnName: columnObj.propName,
				Form: "PRTimeCards",
				Value: columnObj.propValue,
				Mode: columnObj.editable ? 3 : 2, // 2 is Readonly and 3 is editable
				IsCombo: columnObj.isCombo
			}
		});
		let columnValuesString = JSON.stringify(columnValues);
		let rowData = {
			crewTemplateID: null,
			column: columnName,
			payPeriod: this.crewTimecardDataService.payPeriod.PRPCKeyID,
			row: {
				Id: row.KeyID,
				ColumnValues: columnValues
			},
			searchString: null
		};
		if (this.crewTimecardDataService.template != null && this.crewTimecardDataService.template.CrewTemplateID != null)
			rowData.crewTemplateID = this.crewTimecardDataService.template.CrewTemplateID;
		return {
			columnValuesString: columnValuesString,
			currentCell: null,
			employeesToExclude: this.employeesToExclude,
			rowData: rowData
		};
	}

	//operations on timecard rows and cells
	addTimecardRow(ignoreAddingRow: boolean) {
		if (this.isReadOnlyGridTime || this.crewTimecardDataService.readOnlyGrid)
			return;
		if (!this.addingRow || ignoreAddingRow) {
			this.addingRow = true;
			let firstRow = this.dataTable.getItem(this.dataTable.getFirstId());
			let previousEmployee = null;
			if (firstRow != null && firstRow.Employee != null) {
				previousEmployee = firstRow.Employee.substr(0, firstRow.Employee.indexOf("@"));
				if (this.employeesToExclude.indexOf(previousEmployee) > -1) {
					previousEmployee = null;
				}
			}
			if (firstRow == null || previousEmployee == null || firstRow.Employee == "") {
				this.crewTimecardDataService.newRowID++;
				this.largestSortID++;
				let newRow = { isNewRow: true, KeyID: "-1", id: this.crewTimecardDataService.newRowID, Type: null, Employee: null };
				$.each(this.dataTable.config.columns, (loopGridColumnIndex, loopGridColumn) => {
					if (loopGridColumn.id == "Sub Total") {
						/*newRow[loopGridColumn.id] = "=sumHours(" + this.crewTimecardDataService.newRowID + ")";*/
					}
					else
						newRow[loopGridColumn.id] = "";


				});
				//Add Column Property Values
				if (this.firstRowCopy != null) {
					$.each(this.gridData.columnPropertyNames, (key, val) => {
						newRow[val] = this.firstRowCopy[val];
					});
				}
				//handle Type
				if (this.crewTimecardDataService.type != "all") {
					newRow.Type = this.crewTimecardDataService.type + "@row_" + this.crewTimecardDataService.newRowID;
				}
				else if (this.gridData.rowPropertyNames.indexOf("Type") > -1) {
					let newVal = "J@row_" + this.crewTimecardDataService.newRowID;
					let newLabel = "J - Job";
					if (this.columnOptions["Type"].getItem(newVal) == null) {
						this.columnOptions["Type"].add({ id: newVal, value: newLabel, visible: true });
					}
					newRow.Type = newVal;
				}

				//If a single employee is selected, add row will automatically select the first employee
				if (this.crewTimecardDataService.selectedEmployee != null && this.crewTimecardDataService.selectedEmployee != "all") {
					let newVal = this.crewTimecardDataService.selectedEmployee + "@row_" + this.crewTimecardDataService.newRowID;
					let newLabel;
					for (let i = 0; i < this.crewTimecardDataService.employees.length; i++) {
						if (this.crewTimecardDataService.employees[i].Value == this.crewTimecardDataService.selectedEmployee) {
							newLabel = this.crewTimecardDataService.employees[i].Label;
							break;
						}
					}
					this.columnOptions["Employee"].add({ id: newVal, value: newLabel, visible: true });
					newRow.Employee = newVal;
				}

				if (this.gridData.rowPropertyNames.indexOf("udSort") > -1) {
					newRow["udSort"] = this.largestSortID;
					newRow["udSort___@Value"] = this.largestSortID;
				}
				if (this.firstRowCopy == null) {
					this.firstRowCopy = _.cloneDeep(newRow);
				}
				this.dataTable.add(newRow, 0);

				if (newRow.Type != null && newRow.Type != "")
					this.applyLineTypeCSS(newRow.id);
				if (this.gridData.rowPropertyNames.indexOf("EarnCode") > -1 || this.gridData.rowPropertyNames.indexOf("PayType") > -1) {
					this.applyAmountCSS(newRow.id);
				}

				this.dataTable.addCellCss(newRow.id.toString(), "Sub Total", "cellReadOnly");
				//dataTable.editCell(newRow.id, dataTable.config.columns[0].id, false, true);
				this.crewTimecardDataService.rowCount = this.dataTable.count();
				this.crewTimecardDataService.unsubmittedRows++;

				//set time worked read only based on unsubmitted rows
				if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled) {
					this.crewTimecardDataService.timeWorked.setReadOnly(this.crewTimecardDataService.unsubmittedRows < this.crewTimecardDataService.rowCount);
				}

				this.addingRow = false;
				return newRow;
			}
			else {
				if (this.currentEmployeeColumns == null || previousEmployee != this.lastRequestedEmployeeDefault) {
					this.lastRequestedEmployeeDefault = previousEmployee;
					//this.getEmployeeColumnInfo(previousEmployee, this.crewTimecardDataService.payPeriod.PRCo, true);
					if (this.columnInfoByEmployee[previousEmployee] == null) {
						this.getEmployeeColumnInfo(previousEmployee, null, true, true)
					}
					else {
						this.currentEmployeeColumns = this.columnInfoByEmployee[previousEmployee];
						this.addTimecardRow(true);
					}
				}
				else {
					this.crewTimecardDataService.newRowID++;
					this.largestSortID++;
					let newRow = { isNewRow: true, KeyID: "-1", id: this.crewTimecardDataService.newRowID, Type: null, Employee: null };
					if (this.crewTimecardDataService.type != "all") {
						newRow.Type = this.crewTimecardDataService.type + "@row_" + this.crewTimecardDataService.newRowID;
					}
					$.each(this.dataTable.config.columns, (loopGridColumnIndex, loopGridColumn) => {
						let columnName = loopGridColumn.id.substr(loopGridColumn.id.indexOf("@") + 1);
						if (loopGridColumn.id == "Sub Total") {
							/*newRow[loopGridColumn.id] = "=sumHours(" + this.crewTimecardDataService.newRowID + ")";*/
						}
						else if (this.currentEmployeeColumns[columnName] == null) {
							newRow[loopGridColumn.id] = "";
						}
						else {
							//New line types
							//1: Blank value
							//2: Previous value
							//3: Default value
							if (columnName == "Employee" && this.crewTimecardDataService.selectedEmployee != null && this.crewTimecardDataService.selectedEmployee != "all") {
								let prevVal = firstRow["Employee"].substr(0, firstRow[loopGridColumn.id].indexOf("@"));
								if (prevVal != null && prevVal != "null" && prevVal != "") {
									let newVal = prevVal + "@row_" + this.crewTimecardDataService.newRowID;
									let newLabel = this.columnOptions["Employee"].getItem(firstRow[loopGridColumn.id]).value;
									if (this.columnOptions["Employee"].getItem(newVal) == null) {
										this.columnOptions["Employee"].add({ id: newVal, value: newLabel, visible: true });
									}

									newRow["Employee"] = newVal;
								}
								else {
									newRow["Employee"] = "";
								}
							}
							else if (columnName == "Type") {
								if (this.crewTimecardDataService.type == "all") {
									switch (this.currentEmployeeColumns[columnName].NewLineTypeID) {
										case 1:
											let newVal = "J@row_" + this.crewTimecardDataService.newRowID;
											let newLabel = "J - Job";
											if (this.columnOptions[columnName].getItem(newVal) == null) {
												this.columnOptions[columnName].add({ id: newVal, value: newLabel, visible: true });
											}
											newRow.Type = newVal;
											break;
										case 2:
											if (firstRow.Type != null && firstRow.Type != "") {
												let prevVal = firstRow.Type.substr(0, firstRow.Type.indexOf("@"));
												if (prevVal != null && prevVal != "null" && prevVal != "") {
													let newVal = prevVal + "@row_" + this.crewTimecardDataService.newRowID;
													let newLabel = this.columnOptions[columnName].getItem(firstRow[loopGridColumn.id]).value;
													if (this.columnOptions[columnName].getItem(newVal) == null) {
														this.columnOptions[columnName].add({ id: newVal, value: newLabel, visible: true });
													}
													newRow[loopGridColumn.id] = newVal;
												}
												else {
													let newVal = "J@row_" + this.crewTimecardDataService.newRowID;
													let newLabel = "J - Job";
													if (this.columnOptions[columnName].getItem(newVal) == null) {
														this.columnOptions[columnName].add({ id: newVal, value: newLabel, visible: true });
													}
													newRow.Type = newVal;
												}

											}
											else {
												let newVal = "J@row_" + this.crewTimecardDataService.newRowID;
												let newLabel = "J - Job";
												if (this.columnOptions[columnName].getItem(newVal) == null) {
													this.columnOptions[columnName].add({ id: newVal, value: newLabel, visible: true });
												}
												newRow.Type = newVal;
											}
											break;
										case 3:
											if (this.currentEmployeeColumns[columnName].DefaultValue == null) {
												let newVal = "J@row_" + this.crewTimecardDataService.newRowID;
												let newLabel = "J - Job";
												if (this.columnOptions[columnName].getItem(newVal) == null) {
													this.columnOptions[columnName].add({ id: newVal, value: newLabel, visible: true });
												}
												newRow.Type = newVal;
											}
											else {
												//if item is a combobox, add the value to the dropdown
												if (this.sharedColumnInfo[columnName].IsCombo == 1) {
													let newVal = this.currentEmployeeColumns[columnName].DefaultValue + "@row_" + this.crewTimecardDataService.newRowID;
													let newLabel = this.currentEmployeeColumns[columnName].DefaultLabel;
													if (this.columnOptions[columnName].getItem(newVal) == null) {
														this.columnOptions[columnName].add({ id: newVal, value: newLabel, visible: true });
													}
													newRow[loopGridColumn.id] = newVal;
												}
											}
											break;
									}
								}
								else {
									let newVal = this.crewTimecardDataService.type + "@row_" + this.crewTimecardDataService.newRowID;
									newRow.Type = newVal;
								}

							}
							else {
								switch (this.currentEmployeeColumns[columnName].NewLineTypeID) {
									case 1:
										newRow[loopGridColumn.id] = "";
										break;
									case 2:
										if (columnName == "PostDate") {
											let dateString = firstRow[loopGridColumn.id]
											if (firstRow[loopGridColumn.id] != null && firstRow[loopGridColumn.id] != "") {
												//format date into a form that webix understands
												let yyyy = firstRow[loopGridColumn.id].getFullYear().toString();
												let mm = (firstRow[loopGridColumn.id].getMonth() + 1).toString();
												let dd = firstRow[loopGridColumn.id].getDate().toString();
												newRow[loopGridColumn.id] = yyyy + "/" + mm + "/" + dd;
											}
											else {
												newRow[loopGridColumn.id] = null;
											}
										}
										else {
											//if item is a combobox, add value to the dropdown
											if (this.sharedColumnInfo[columnName].IsCombo == 1) {
												if (firstRow[loopGridColumn.id] != null && firstRow[loopGridColumn.id] != "") {
													let prevVal = firstRow[loopGridColumn.id].substr(0, firstRow[loopGridColumn.id].indexOf("@"));
													if (prevVal != null && prevVal != "null" && prevVal != "") {
														let newVal = prevVal + "@row_" + this.crewTimecardDataService.newRowID;
														let newLabel = this.columnOptions[columnName].getItem(firstRow[loopGridColumn.id]).value;
														if (this.columnOptions[columnName].getItem(newVal) == null) {
															this.columnOptions[columnName].add({ id: newVal, value: newLabel, visible: true });
														}

														newRow[loopGridColumn.id] = newVal;
														newRow[loopGridColumn.id + "___@Value"] = firstRow[loopGridColumn.id + "___@Value"];
													}
													else {
														newRow[loopGridColumn.id] = "";
														newRow[loopGridColumn.id + "___@Value"] = "";
													}

												}
												else {
													newRow[loopGridColumn.id] = "";
													newRow[loopGridColumn.id + "___@Value"] = "";
												}
											}
											else {
												newRow[loopGridColumn.id] = firstRow[loopGridColumn.id];
											}
										}

										break;
									case 3:
										if (this.currentEmployeeColumns[columnName].DefaultValue == null) {
											newRow[loopGridColumn.id] = "";
										}
										else {
											//if item is a combobox, add the value to the dropdown
											if (this.sharedColumnInfo[columnName].IsCombo == 1) {
												let newVal = this.currentEmployeeColumns[columnName].DefaultValue + "@row_" + this.crewTimecardDataService.newRowID;
												let newLabel = this.currentEmployeeColumns[columnName].DefaultLabel;
												if (this.columnOptions[columnName].getItem(newVal) == null) {
													this.columnOptions[columnName].add({ id: newVal, value: newLabel, visible: true });
												}
												newRow[loopGridColumn.id] = newVal;
												newRow[loopGridColumn.id + "___@Value"] = newLabel;
											}
											else {
												newRow[loopGridColumn.id] = this.currentEmployeeColumns[columnName].DefaultValue;
											}
										}
										break;
								}
							}


						}
					});
					//Add Column Property Values
					if (this.firstRowCopy != null) {
						$.each(this.gridData.columnPropertyNames, (key, val) => {
							newRow[val] = this.firstRowCopy[val];
						});
					}
					if (this.gridData.rowPropertyNames.indexOf("udSort") > -1) {
						newRow["udSort"] = this.largestSortID;
						newRow["udSort___@Value"] = this.largestSortID;
					}
					if (this.firstRowCopy == null) {
						this.firstRowCopy = _.cloneDeep(newRow);
					}
					this.dataTable.add(newRow, 0);

					if (newRow.Type != null && newRow.Type != "")
						this.applyLineTypeCSS(newRow.id);
					if (this.gridData.rowPropertyNames.indexOf("EarnCode") > -1 || this.gridData.rowPropertyNames.indexOf("PayType") > -1) {
						this.applyAmountCSS(newRow.id);
					}
					this.dataTable.addCellCss(newRow.id.toString(), "Sub Total", "cellReadOnly");
					this.crewTimecardDataService.rowCount = this.dataTable.count();
					this.crewTimecardDataService.unsubmittedRows++;

					//set time worked read only based on unsubmitted rows
					if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled) {
						this.crewTimecardDataService.timeWorked.setReadOnly(this.crewTimecardDataService.unsubmittedRows < this.crewTimecardDataService.rowCount);
					}

					this.addingRow = false;
					return newRow;
				}
			}
		}
	}

	bindDefaultValues(rowID) {
		let row = this.dataTable.getItem(rowID);
		let employee = row["Employee"].substr(0, row["Employee"].indexOf("@"));
		let employeeDependentColumns = this.sharedColumnInfo["Employee"].DependentColumns != null ? this.sharedColumnInfo["Employee"].DependentColumns.split(",") : [];
		$.each(this.dataTable.config.columns, (loopGridColumnIndex, loopGridColumn) => {
			let columnName = loopGridColumn.id.substr(loopGridColumn.id.indexOf("@") + 1);
			if (loopGridColumn.id != "SubTotal" && loopGridColumn.id != "Employee" && columnName != "Hours" && this.columnInfoByEmployee[employee][columnName] != null) {

				switch (this.columnInfoByEmployee[employee][columnName].NewLineTypeID) {
					case 3:
						if (this.columnInfoByEmployee[employee][columnName].DefaultValue == null) {
							row[loopGridColumn.id] = "";
							row[loopGridColumn.id + "___@Value"] = "";
						}
						else {
							//if item is a combobox, add the value to the dropdown
							let cellReadOnly = false;
							if (row.Type != null && row.Type != "" && row.Type.substr(0, row.Type.indexOf("@")) != "") {
								cellReadOnly = this.isCellReadOnly(row, columnName);
							}
							if (!cellReadOnly) {
								if (this.sharedColumnInfo[columnName].IsCombo == 1) {
									//bind the default value to the cell and add to dropdown list if it doesn't exist
									let newValID = this.columnInfoByEmployee[employee][columnName].DefaultValue + "@row_" + rowID;
									let newValLabel = this.columnInfoByEmployee[employee][columnName].DefaultLabel;
									let valueFound = this.columnOptions[columnName].getItem(newValID) != null;
									if (employeeDependentColumns.indexOf(columnName) > -1) {
										//if column is dependent of employee, verify the default value exists and perform dependent value rebinding
										if (valueFound) {
											row[loopGridColumn.id] = newValID;
											row[loopGridColumn.id + "___@Value"] = newValLabel;
										}
										else {
											row[loopGridColumn.id] = "";
											row[loopGridColumn.id + "___@Value"] = "";
										}
										if (this.sharedColumnInfo[columnName].DependentColumns != null) {
											let dependentColumns = this.sharedColumnInfo[columnName].DependentColumns.split(",");
											let isTypeUsed = row.Type != null && row.Type != "" && row.Type.substr(0, row.Type.indexOf("@")) != "";
											$.each(dependentColumns, (dependentKey, dependentCol) => {
												if (this.dependentQueue.indexOf(dependentCol) == -1 && this.gridData.rowPropertyNames.indexOf(dependentCol) > -1) {
													//dependentQueue.push(dependentCol);
													if (!isTypeUsed || !this.isCellReadOnly(row, dependentCol)) {
														this.dependentQueue.push(dependentCol);
													}
													else {
														row[dependentCol] = "";
														row[dependentCol + '___@Value'] = "";
													}
												}
											});
										}
									}
									else {
										if (!valueFound) {
											this.columnOptions[columnName].add({ id: newValID, value: newValLabel, visible: true });
										}
										row[loopGridColumn.id] = newValID;
										row[loopGridColumn.id + '___@Value'] = newValLabel;
									}
								}
								else {
									row[loopGridColumn.id] = this.columnInfoByEmployee[employee][columnName].DefaultValue;
								}
							}
							else {
								row[loopGridColumn.id] = "";
								row[loopGridColumn.id + "___@Value"] = "";
							}

						}
						break;
				}
			}
		});
		if (this.dependentQueue.length > 0) {
			this.getCellValues(this.dependentQueue[0], row, true);
		}
		else {
			this.dataTable.refresh();
			if (this.nextEditor != null) {
				this.dataTable.editCell(this.nextEditor.row, this.nextEditor.column);
				this.dataTable.editNext();
			}
			this.nextEditor = null;
			this.crewTimecardDataService.loadingValues = false;
		}
		webix.delay(() => {
			this.dataTable.refresh();
		}, this.dataTable);
	}

	bindPossibleValues(possibleValues, isDependent, columnName, row) {
		let  employee = "";
		if (row["Employee"] != null && row["Employee"] != "")
			employee = row["Employee"].substr(0, row["Employee"].indexOf("@"));
		if (this.columnOptions[columnName] != null) {
			this.lastRequestedRow = row.id;

			if (this.sharedColumnInfo[columnName].ValidationDataType == "bit") {
				if (possibleValues.length > 0) {
					row[columnName] = possibleValues[0].Value;
					this.dataTable.refresh();
				}
			}
			else {
				//save used values
				this.savedValues = [];
				this.dataTable.eachRow((currentRow) => {

					let currentItem = this.dataTable.getItem(currentRow);
					let listValue = this.columnOptions[columnName].getItem(currentItem[columnName]);

					if (listValue != null && this.containsObject(listValue, this.savedValues) == -1) {
						listValue.visible = false;
						this.savedValues.push(listValue);
					}
				});
				//clear out previous lookup values
				this.columnOptions[columnName].clearAll();

				//add empty value for clearing chosen options
				if (columnName != "Type") {
					if (columnName == "udKDSTrackerID") {
						this.columnOptions[columnName].add({ id: "null", value: "Standard Timecard", visible: true, popUpLabel: "Standard Timecard" });
					}
					else
						this.columnOptions[columnName].add({ id: "null", value: "", visible: true, popUpLabel: "" });
				}
				let  options = possibleValues.map((valueObj) => {
					return { id: valueObj.Value + "@row_" + row.id, value: valueObj.Label, visible: true, popUpLabel: valueObj.PopUpLabel };
				});

				//re-add saved values
				let  savedValueIds = options.map((x) => { return x.id });
				for (let  i = 0; i < this.savedValues.length; i++) {
					if (savedValueIds.indexOf(this.savedValues[i].id) < 0) {
						options.push(this.savedValues[i]);
						savedValueIds.push(this.savedValues[i].id);
					}
				}

				this.columnOptions[columnName].parse(options);
				this.columnOptions[columnName].refresh();
			}



			if (columnName == "Employee")
				this.employeeListBound = true;
			if (!isDependent) {
				this.dataTable.editCell(row.id, columnName, false, true);
				this.processingRow = false;
				this.crewTimecardDataService.loadingValues = false;
			}
			else {
				if (columnName != "PostDate" && columnName != "Memo" && this.sharedColumnInfo[columnName].ValidationDataType != "bit") {
					let  valueFound = false;
					let  value = "";
					if (row[columnName] != null && row[columnName] != "")
						value = row[columnName].substr(0, row[columnName].indexOf("@"));
					$.each(possibleValues, (key, val) => {
						if (value == val.Value) {
							valueFound = true;
							return false;
						}
					});
					if (!valueFound || this.sharedColumnInfo[columnName].IsAutoSelectFirstValue) {
						//auto select first
						let  cellReadOnly = false;
						if (row.Type != null && row.Type != "" && row.Type.substr(0, row.Type.indexOf("@")) != "") {
							cellReadOnly = this.isCellReadOnly(row, columnName);
						}
						if (!cellReadOnly && this.sharedColumnInfo[columnName].IsAutoSelectFirstValue && possibleValues.length > 0) {
							row[columnName] = possibleValues[0].Value + "@row_" + row.id;
							row[columnName + "___@Value"] = possibleValues[0].Label;
						}
						else {
							//clear value if it no longer exists
							row[columnName] = "";
							row[columnName + "___@Value"] = "";
						}
						this.dataTable.refresh();
						//push this column's dependent columns to the dependent column stack if the value changed
						if (value != null && value != "" && this.sharedColumnInfo[columnName].DependentColumns != null && this.sharedColumnInfo[columnName].DependentColumns != "") {
							let  dependentColumns = this.sharedColumnInfo[columnName].DependentColumns.split(",");
							$.each(dependentColumns, (key, val) => {

								if (this.gridData.rowPropertyNames.indexOf(val) > -1 && this.dependentQueue.indexOf(val) == -1 && this.sharedColumnInfo[val] != null && this.sharedColumnInfo[val].IsCombo == 1) {
									if (this.sharedColumnInfo[val].ColumnVisibilityModeID == 1 || this.sharedColumnInfo[val].ColumnVisibilityModeID == 3) {
										let  isTypeUsed = row.Type != null && row.Type != "" && row.Type.substr(0, row.Type.indexOf("@")) != "";
										if (!isTypeUsed || !this.isCellReadOnly(row, val)) {
											this.dependentQueue.push(val);
										}
									}
									else {
										row[val] = "";
										row[val + '___@Value'] = "";
									}
								}
							});
						}
					}
				}
				//remove first element from dependent queue, as it is now done binding
				if (this.dependentQueue.length > 0)
					this.dependentQueue.shift();
				if (this.dependentQueue.length == 0) {
					//if Employee was changed, bind default values for the row
					if (this.rebindingEmployee) {
						this.rebindingEmployee = false;
						if (this.columnInfoByEmployee[employee] == null) {
							this.getEmployeeColumnInfo(employee, row.id, null, null);
						}
						else {
							this.bindDefaultValues(row.id);
						}
					}
					else {
						this.crewTimecardDataService.loadingValues = false;
						if (this.nextEditor != null) {
							this.dataTable.editCell(this.nextEditor.row, this.nextEditor.column);
							this.dataTable.editNext();
							this.nextEditor = null;
						}
					}

				}
				else {
					this.getCellValues(this.dependentQueue[0], row, true);
				}
			}
		}
		else {
			//remove first element from dependent queue, as it is now done binding
			if (isDependent) {
				if (this.dependentQueue.length > 0)
					this.dependentQueue.shift();
				if (this.dependentQueue.length == 0) {
					//if Employee was changed, bind default values for the row
					if (this.rebindingEmployee) {
						this.rebindingEmployee = false;
						if (this.columnInfoByEmployee[employee] == null) {
							this.getEmployeeColumnInfo(employee, row.id, null, null);
						}
						else {
							this.bindDefaultValues(row.id);
						}
					}
					else {
						this.crewTimecardDataService.loadingValues = false;
						if (this.nextEditor != null) {
							this.dataTable.editNext();
							//this.dataTable.editNext(true, this.nextEditor);
							this.nextEditor = null;
						}
					}

				}
				else {
					this.getCellValues(this.dependentQueue[0], row, true);
				}
			}

		}
	}

	//recalculates the hours column when Start/Stop in row is modified
	calculateHours(row, colPrefix, isStartTime, isStopTime, isBreakHours, stateValue) {
		let startTime, stopTime, breakHours = null;
		let startColName = colPrefix + "@StartTime";
		let stopColName = colPrefix + "@StopTime";
		let time24HourMode = this.portalSettings.Timecard24Hours.ConfigValue === "1";
		if (isStartTime) {
			startTime = (stateValue == "00:00" || stateValue == "0:00") ? Date.today() : this.timeParserService.parseTime(stateValue);
		}
		else if (isStopTime) {
			stopTime = (stateValue == "00:00" || stateValue == "0:00") ? Date.today().addDays(1) : this.timeParserService.parseTime(stateValue);
		}
		else if (isBreakHours && stateValue != null && stateValue != "") {
			breakHours = parseFloat(stateValue);
		}

		if (startTime == null && !isStartTime) {
			startTime = (row[startColName] == "00:00" || row[startColName] == "0:00") ? Date.today() : this.timeParserService.parseTime(row[startColName]);
		}
		if (stopTime == null && !isStopTime) {
			stopTime = (row[stopColName] == "00:00" || row[stopColName] == "0:00") ? Date.today().addDays(1) : this.timeParserService.parseTime(row[stopColName]);
		}
		if (breakHours == null && !isBreakHours && row[colPrefix + "@BreakHours"] != null && row[colPrefix + "@BreakHours"] != "") {
			breakHours = parseFloat(row[colPrefix + "@BreakHours"]);
		}

		if (startTime != null && stopTime != null) {
			let elapsedHours = (stopTime - startTime) / (1000 * 60 * 60.0);
			let isEndTimeGreaterThanStartTime = elapsedHours > 0;
			let dayInHours = time24HourMode ? 24 : 12;
			elapsedHours = isEndTimeGreaterThanStartTime
				? elapsedHours
				: dayInHours + elapsedHours;
			elapsedHours -= breakHours;
			row[colPrefix + "@Hours"] = parseFloat(elapsedHours.toFixed(2));
		}
  }

	//validate rows for timecard save
	validateRows() {
		let rowProperties = this.gridData.rowPropertyNames;
		let  postDateRowProp = false;
		$.each(rowProperties, (key, val) => {
			if (val == "PostDate") {
				postDateRowProp = true;
				return false;
			}
		});
		let startDateValueProp = false;
		let stopDateValueProp = false;
		this.gridData.valuePropertyNames.forEach((propertyName) => {
			if (propertyName == "@StartTime") {
				startDateValueProp = true;
			}
			if (propertyName == "@StopTime") {
				stopDateValueProp = true;
			}
		});
		let  rowID = this.dataTable.getFirstId();
		let  row = this.dataTable.getItem(rowID);
		let  missingEmployee = [];
		let  invalidRows = [];
		let  missingPhase = [];
		let  removePhase = [];
		let  missingDate = [];
		let invalidDate = [];
		let invalidTime = [];
		let  missingRequired = [];
		let  missingHours = [];
		let  missingRevCode = [];
		let  missingEquipPhase = [];
		let  isUsageUnitValueGroup = false;
		//#235105: Check value grouping is included with UsageUnits
		this.dataTable.eachColumn((column) => {
			if (column.indexOf('@UsageUnits') > -1) {
				isUsageUnitValueGroup = true;
				return;
			}
		});

		this.dataTable.eachRow((rowID) => {
			row = this.dataTable.getItem(rowID);
			//check if new row has hours
			if (row.isNewRow && this.portalSettings.AllowZeroHourCrewLine.ConfigValue != "1") {
				let  valueFound = false;
				//#235105: Check whether usage unit has been added on Value group, if so then ensure any one column has filled up with value. 
				if (isUsageUnitValueGroup) {
					$.each(row, (rowKey: string, rowValue) => {
						if (rowKey.indexOf("@Hours") > -1 || rowKey == "Hours" || rowKey.indexOf("UsageUnits") > -1) {
							if (rowValue != null && rowValue != 0 && rowValue != "") {
								valueFound = true;
								return false;
							}
						}
					});
				}
				//If Usage unit is not in Value group, ensure that hours has been filled up.
				else {
					$.each(row, (rowKey: string, rowValue) => {
						if (rowKey.indexOf("@Hours") > -1 || rowKey == "Hours") {
							if (rowValue != null && rowValue != 0 && rowValue != "") {
								valueFound = true;
								return false;
							}
						}
					});
				}

				if (!valueFound) {
					missingHours.push(rowID);
				}
			}
			else {
				let  valueFound = false;
				//#235105: Check whether usage unit has been added on Value group, if so then ensure any one column has filled up with value. 
				if (isUsageUnitValueGroup) {
					$.each(row, (rowKey: string, rowValue) => {
						if (rowKey.indexOf("@Hours") > -1 || rowKey == "Hours" || rowKey.indexOf("UsageUnits") > -1) {
							if (rowValue != null && rowValue != "") {
								valueFound = true;
								return false;
							}
						}
					});
				}
				//If Usage unit is not in Value group, ensure that hours has been filled up.
				else {
					$.each(row, (rowKey: string, rowValue) => {
						if (rowKey.indexOf("@Hours") > -1 || rowKey == "Hours") {
							if (rowValue != null && rowValue != "") {
								valueFound = true;
								return false;
							}
						}
					});
				}
				if (!valueFound) {
					missingHours.push(rowID);
				}
			}

			//check Employee
			if (row["Employee"] == null || row["Employee"].substr(0, row["Employee"].indexOf("@")) == "") {
				missingEmployee.push(rowID);
			}
			//check that Phase exists if Job exists
			if ((row["Job"] != null && row["Job"].substr(0, row["Job"].indexOf("@")) != "" && row["Job"] != "null") ||
				(row["JCCoJobCombined"] != null && row["JCCoJobCombined"].substr(0, row["JCCoJobCombined"].indexOf("@")) != "" && row["JCCoJobCombined"] != "null")) {
				let  valid = false;
				if (row["Type"] == null || row["Type"] == "" || row["Type"].substr(0, row["Type"].indexOf("@")) == "J") {
					if (row["Phase"] == null || row["Phase"].substr(0, row["Phase"].indexOf("@")) == "" || row["Phase"] == "null") {
						missingPhase.push(rowID);
					}
				}
				else if (row["Type"].substr(0, row["Type"].indexOf("@")) == "M") {
					//if line is mechanic, make sure there is no phase
					if (row["Phase"] == null || row["Phase"].substr(0, row["Phase"].indexOf("@")) == "" || row["Phase"] == "null") {
						//all good
					}
					else {
						removePhase.push(rowID);
					}

				}
			}
			//check that RevCode or EquipPhase exists if Equipment Exists
			if (row["Equipment"] != null && row["Equipment"].substr(0, row["Equipment"].indexOf("@")) != "" && row["Equipment"] != "null") {
				let  valid = false;
				if (this.sharedColumnInfo["RevCode"] != null && this.sharedColumnInfo["RevCode"].ColumnVisibilityModeID != 1 && !this.isCellReadOnly(row, "RevCode") && (row["RevCode"] == null || row["RevCode"].substr(0, row["RevCode"].indexOf("@")) == "" || row["RevCode"] == "null")) {
					missingRevCode.push(rowID);
				}
				if (this.sharedColumnInfo["EquipPhase"] != null && this.sharedColumnInfo["EquipPhase"].ColumnVisibilityModeID != 1 && !this.isCellReadOnly(row, "EquipPhase") && (row["EquipPhase"] == null || row["EquipPhase"].substr(0, row["EquipPhase"].indexOf("@")) == "" || row["EquipPhase"] == "null")) {
					missingEquipPhase.push(rowID);
				}
			}
			let timeValid = true;
			//check Start/Stop times for invalid characters
			if (row["StartTime"] != null) {
				let timeValue = _this.timeParserService.parseStartStop(row["StartTime"], "StartTime", true);
				
				if (timeValue == "Invalid Time") {
					invalidTime.push(rowID);
					timeValid = false;
				}
			}
			if (timeValid && row["StopTime"] != null) {
				let timeValue = _this.timeParserService.parseStartStop(row["StopTime"], "StopTime", true);

				if (timeValue == "Invalid Time") {
					invalidTime.push(rowID);
					timeValid = false;
				}
			}
			//check Start/Stop if it is a value property
			if (startDateValueProp) {
				$.each(row, (rowKey: string, rowVal) => {
					if (timeValid && rowKey.includes("StartTime")) {
						let timeValue = _this.timeParserService.parseStartStop(rowVal, "StartTime", true);
						if (timeValue == "Invalid Time") {
							invalidTime.push(rowID);
							timeValid = false;
							return false;
						}
					}
				})
			}
			else if (timeValid && stopDateValueProp) {
				$.each(row, (rowKey: string, rowVal) => {
					if (timeValid && rowKey.includes("StopTime")) {
						let timeValue = _this.timeParserService.parseStartStop(rowVal, "StopDate", true);
						if (timeValue == "Invalid Time") {
							invalidTime.push(rowID);
							timeValid = false;
							return false;
						}
					}
				})
			}

			//check date
			if (postDateRowProp) {
				if (row["PostDate"] == "") {
					missingDate.push(rowID);
				}
				else {
					//validate date is within payperiod
					let date = moment(Date.parse(row["PostDate"]));
					if (date.isBefore(this.crewTimecardDataService.payPeriod.StartDateMoment, 'day') || date.isAfter(this.crewTimecardDataService.payPeriod.EndDateMoment, 'day')) {
						invalidDate.push(rowID);
					}

				}
			}

			//check required fields are filled in
			rowProperties.forEach((propertyName) => {
				if (propertyName != "PostDate") {
					let  cellValue = null;
					if (typeof row[propertyName] === 'string') {
						let  index = row[propertyName].indexOf("@");
						cellValue = index > -1 ? row[propertyName].substr(0, index) : row[propertyName];
					}
					else {
						cellValue = row[propertyName];
					}

					if (row.Type != null && row.Type != "") {
						let type = row.Type.substr(0, row.Type.indexOf("@"));
						if (this.crewTimecardDataService.columnInfoByType[type] != null && this.crewTimecardDataService.columnInfoByType[type][propertyName] != null && propertyName != "PostDate" && this.crewTimecardDataService.columnInfoByType[type][propertyName].IsRequired && !this.isCellReadOnly(row, propertyName)) {
							if ((row[propertyName] == null || cellValue == "" || row[propertyName] == "null") && this.crewTimecardDataService.columnInfoByType[type][propertyName].ValidationDataType != "bit") {
								missingRequired.push({ row: rowID, field: propertyName });
							}
						}
					}
					else {
						if (this.sharedColumnInfo[propertyName] != null && propertyName != "PostDate" && this.sharedColumnInfo[propertyName].IsRequired && !this.isCellReadOnly(row, propertyName)) {
							if ((row[propertyName] == null || cellValue == "" || row[propertyName] == "null") && this.sharedColumnInfo[propertyName].ValidationDataType != "bit") {
								missingRequired.push({ row: rowID, field: propertyName });
							}
						}
					}

				}
			});

		});
		return {
			invalidRows: invalidRows,
			missingPhase: missingPhase,
			removePhase: removePhase,
			missingDate: missingDate,
			invalidDate: invalidDate,
			invalidTime: invalidTime,
			missingEmployee: missingEmployee,
			missingRequired: missingRequired,
			missingHours: missingHours,
			missingRevCode: missingRevCode,
			missingEquipPhase: missingEquipPhase
		};
	}

	saveCrewTimecard(finishCrewTimecardSave: Function, submitData, fieldToChange) {
		let changedData = this.crewTimecardManagerService.getChangedData(this.dataTable);
		//TODO reset timeworked calculations?
		//crewGridDataService.totalsCalculated = false;
		let timecardRows = [];
		$.each(changedData, (uniqueRowId, updatedData: any) => {
			timecardRows.push({
				Id: updatedData.keyId,
				ColumnValues: $.map(updatedData.values, (updatedValue, columnName) => {
					return {
						ColumnName: columnName,
						Form: "PRTimeCards",
						Value: updatedValue
					};
				})
			});
		});

		if (timecardRows.length > 0) {
			this.crewTimecardGridService.saveCrewTimecard(
				this.crewTimecardDataService.payPeriod.KeyID,
				timecardRows,
				this.crewTimecardDataService.template.CrewTemplateID
			).then((response: any) => {
				finishCrewTimecardSave(response.success, submitData, fieldToChange, response.error);
			}, (reason) => {
				//timeoutService.refreshTimeout();
				//this.alert = { type: 'danger', msg: "An error occured when attempting to save the timecard." }
				finishCrewTimecardSave(false, submitData, fieldToChange, "An error occured when attempting to save the timecard.");
			})
    }
		else {

			finishCrewTimecardSave(true, submitData, fieldToChange);
    }
  }

	//CSS stuff
	applyAmountCSS(rowID) {
		let row = this.dataTable.getItem(rowID);
		//only apply this CSS if the row is editable
		if (row.IsReadOnly != "1" && row.IsSubmitted != "1" && row.IsApproved != "1") {
			if (this.isAmountRow(rowID)) {
				$.each(this.gridData.columns, (key, column) => {
					let columnName = column.id;
					if (columnName.indexOf("@StartTime") > -1 || columnName.indexOf("@StopTime") > -1 || columnName.indexOf("@BreakHours") > -1) {
						this.dataTable.addCellCss(rowID, columnName, "cellReadOnly");
					}
				});
			}
			else {
				$.each(this.gridData.columns, (key, column) => {
					let columnName = column.id;
					if (columnName.indexOf("@StartTime") > -1 || columnName.indexOf("@StopTime") > -1 || columnName.indexOf("@BreakHours") > -1) {
						this.dataTable.removeCellCss(rowID, columnName, "cellReadOnly");
					}
				});
			}
		}
	}

	applyLineTypeCSS(rowID) {
		let row = this.dataTable.getItem(rowID);
		let rowLineType = row.Type.substr(0, row.Type.indexOf("@"));

		if (rowLineType != null && rowLineType != "" && rowLineType != "null") {
			//iterate over row properties using the row properties list
			$.each(this.gridData.rowPropertyNames, (key, propertyName) => {
				//row[propertyName + '___@Value'] = row[propertyName];
				//if column's linetype does not match up with row, clear value and make read only
				if (this.sharedColumnInfo[propertyName] != null && this.sharedColumnInfo[propertyName].LineType != null) {
					let colLineType = this.sharedColumnInfo[propertyName].LineType;
					if (rowLineType == "J") {
						if (colLineType != "J" && colLineType != "A" && colLineType != "F" && colLineType != "T") {
							row[propertyName] = "";
							row[propertyName + "___@Value"] = "";
							this.dataTable.addCellCss(rowID, propertyName, "cellReadOnly");
						}
					}
					else if (rowLineType == "S") {
						if ((colLineType != "S" && colLineType != "A" && colLineType != "T") || propertyName == "Job") {
							row[propertyName] = "";
							row[propertyName + "___@Value"] = "";
							this.dataTable.addCellCss(rowID, propertyName, "cellReadOnly");
						}
					}
					else if (rowLineType == "M") {
						if (colLineType != "M" && colLineType != "A" && colLineType != "F") {
							row[propertyName] = "";
							row[propertyName + "___@Value"] = "";
							this.dataTable.addCellCss(rowID, propertyName, "cellReadOnly");
						}
					}
				}
			});

			//iterate over row values 
			$.each(this.gridData.valuePropertyNames, (key, propertyName) => {
				let columnName = propertyName.slice(1);
				//if column's linetype does not match up with row, clear value and make read only
				if (this.sharedColumnInfo[columnName] != null && this.sharedColumnInfo[columnName].LineType != null) {
					let colLineType = this.sharedColumnInfo[columnName].LineType;
					if (rowLineType == "J") {
						if (colLineType != "J" && colLineType != "A" && colLineType != "F" && colLineType != "T") {
							$.each(row, (rowKey: string, rowVal) => {
								if (rowKey.indexOf("@") > -1) {
									let resolvedPropName = rowKey.substr(rowKey.indexOf("@") + 1);
									if (resolvedPropName == columnName) {
										this.dataTable.addCellCss(rowID, rowKey, "cellReadOnly");
									}
								}
							});
						}
					}
					else if (rowLineType == "S") {
						if ((colLineType != "S" && colLineType != "A" && colLineType != "T") || columnName == "Job") {
							$.each(row, (rowKey: string, rowVal) => {
								if (rowKey.indexOf("@") > -1) {
									let resolvedPropName = rowKey.substr(rowKey.indexOf("@") + 1);
									if (resolvedPropName == columnName) {
										this.dataTable.addCellCss(rowID, rowKey, "cellReadOnly");
									}
								}
							});
						}
					}
					else if (rowLineType == "M") {
						if (colLineType != "M" && colLineType != "A" && colLineType != "F") {
							$.each(row, (rowKey: string, rowVal) => {
								if (rowKey.indexOf("@") > -1) {
									let resolvedPropName = rowKey.substr(rowKey.indexOf("@") + 1);
									if (resolvedPropName == columnName) {
										this.dataTable.addCellCss(rowID, rowKey, "cellReadOnly");
									}
								}
							});
						}
					}
				}
			});
		}
	}

	//Time Worked
	calculateTimecardTotals() {
		let totalsByEmployee = {};
		//TODO - figure out how to use this
		let totalsCalculated = false;

		//Get EarnCodes and PayTypes to exclude
		let earnCodesToExclude = [];
		let payTypesToExclude = [];
		if (this.portalSettings.EarnCodesToExcludeTimeValidation.ConfigValue != null && this.portalSettings.EarnCodesToExcludeTimeValidation.ConfigValue != "") {
			earnCodesToExclude = this.portalSettings.EarnCodesToExcludeTimeValidation.ConfigValue.split(",");
			for (let i = 0; i < earnCodesToExclude.length; i++) {
				earnCodesToExclude[i] = parseInt(earnCodesToExclude[i]);
			}
		}
		else {
			earnCodesToExclude = [];
		}
		if (this.portalSettings.PayTypesToExcludeTimeValidation.ConfigValue != null && this.portalSettings.PayTypesToExcludeTimeValidation.ConfigValue != "") {
			payTypesToExclude = this.portalSettings.PayTypesToExcludeTimeValidation.ConfigValue.split(",");
			for (let i = 0; i < payTypesToExclude.length; i++) {
				payTypesToExclude[i] = parseInt(payTypesToExclude[i]);
			}
		}
		else {
			payTypesToExclude = [];
		}

		//check if earncode or paytype is a column group
		let earnCodeIndex = this.gridData.columnPropertyNames.indexOf("EarnCode");
		let isEarnCodeColumn = earnCodeIndex > -1;
		let payTypeIndex = this.gridData.columnPropertyNames.indexOf("SMPayType");
		let isPayTypeColumn = payTypeIndex > -1;
		let totals = {};
		this.rawRows.forEach((row) => {
			if (row.Employee != null && row.Employee != "") {
				//initialize total by employee
				let employee = row.Employee.substr(0, row.Employee.indexOf("@"));
				if (totalsByEmployee[employee] == null) {
					totalsByEmployee[employee] = {};
				}

				let exclude = false;
				//check if type exists, else treat it as a "J" type
				if (row.Type != null && row.Type != "") {
					let type = row.Type.substr(0, row.Type.indexOf("@"));
					if (type == "S") {
						//if line is an "S" type, use paytype to determine if the row is excluded
						if (isPayTypeColumn) {
							//iterate through columns, and check the value of the payType
							$.each(row, (key: string, val) => {
								if (key.indexOf("@Hours") > -1 && val != null && val != "") {
									//get payType value from column name
									let columnValueParts = key.split("___");
									let payType = parseInt(columnValueParts[payTypeIndex]);
									//if payType is not excluded, add it to totals
									if (payTypesToExclude.indexOf(payType) == -1) {
										let index = key.search(/\d\d\d\d-\d\d-\d\d/);
										let dateString = key.substr(index, 10);
										//dates are always in the form of yyyy-mm-dd regardless of locale
										if (totalsByEmployee[employee][dateString] == null) {
											totalsByEmployee[employee][dateString] = { timecardHours: 0, otherHours: 0, totalHours: 0 }
											totalsByEmployee[employee][dateString].timecardHours = parseFloat(val);
											totalsByEmployee[employee][dateString].totalHours = parseFloat(val);
										}
										else {
											totalsByEmployee[employee][dateString].timecardHours += parseFloat(val);
											totalsByEmployee[employee][dateString].totalHours += parseFloat(val);
										}
									}
								}
							});
						}
						else {
							//check the row value of paytype to see if it is not an excluded code
							if (row.SMPayType != null && row.SMPayType != "" && row.SMPayType != "null") {
								let payType = parseInt(row.SMPayType.substr(0, row.SMPayType.indexOf("@")));
								if (payTypesToExclude.indexOf(payType) > -1) {
									exclude = true;
								}
							}
							//if it is not excluded, add the hours to the totals
							if (!exclude) {
								$.each(row, (key: string, val) => {
									if (key.indexOf("@Hours") > -1 && val != null && val != "") {
										let index = key.search(/\d\d\d\d-\d\d-\d\d/);
										let dateString = key.substr(index, 10);
										//dates are always in the form of yyyy-mm-dd regardless of locale
										if (totalsByEmployee[employee][dateString] == null) {
											totalsByEmployee[employee][dateString] = { timecardHours: 0, otherHours: 0, totalHours: 0 }
											totalsByEmployee[employee][dateString].timecardHours = parseFloat(val);
											totalsByEmployee[employee][dateString].totalHours = parseFloat(val);
										}
										else {
											totalsByEmployee[employee][dateString].timecardHours += parseFloat(val);
											totalsByEmployee[employee][dateString].totalHours += parseFloat(val);
										}
									}
								});
							}

						}
					}
					else {
						if (isEarnCodeColumn) {
							//iterate through columns, and check the value of the earncode
							$.each(row, (key: string, val) => {
								if (key.indexOf("@Hours") > -1 && val != null && val != "") {
									//get earncode value from column name
									let columnValueParts = key.split("___");
									let earnCode = parseInt(columnValueParts[earnCodeIndex]);
									//if earncode is not excluded, add it to totals
									if (earnCodesToExclude.indexOf(earnCode) == -1) {
										let index = key.search(/\d\d\d\d-\d\d-\d\d/);
										let dateString = key.substr(index, 10);
										//dates are always in the form of yyyy-mm-dd regardless of locale
										if (totalsByEmployee[employee][dateString] == null) {
											totalsByEmployee[employee][dateString] = { timecardHours: 0, otherHours: 0, totalHours: 0 }
											totalsByEmployee[employee][dateString].timecardHours = parseFloat(val);
											totalsByEmployee[employee][dateString].totalHours = parseFloat(val);
										}
										else {
											totalsByEmployee[employee][dateString].timecardHours += parseFloat(val);
											totalsByEmployee[employee][dateString].totalHours += parseFloat(val);
										}
									}
								}
							});
						}
						else {
							//check the row value of earncode to see if it is not an excluded code
							if (row.EarnCode != null && row.EarnCode != "" && row.Earncode != "null") {
								let earnCode = parseInt(row.EarnCode.substr(0, row.EarnCode.indexOf("@")));
								if (earnCodesToExclude.indexOf(earnCode) > -1) {
									exclude = true;
								}
							}
							//if it is not excluded, add the hours to the totals
							if (!exclude) {
								$.each(row, (key: string, val) => {
									if (key.indexOf("@Hours") > -1 && val != null && val != "") {
										let index = key.search(/\d\d\d\d-\d\d-\d\d/);
										let dateString = key.substr(index, 10);
										//dates are always in the form of yyyy-mm-dd regardless of locale
										if (totalsByEmployee[employee][dateString] == null) {
											totalsByEmployee[employee][dateString] = { timecardHours: 0, otherHours: 0, totalHours: 0 }
											totalsByEmployee[employee][dateString].timecardHours = parseFloat(val);
											totalsByEmployee[employee][dateString].totalHours = parseFloat(val);
										}
										else {
											totalsByEmployee[employee][dateString].timecardHours += parseFloat(val);
											totalsByEmployee[employee][dateString].totalHours += parseFloat(val);
										}
									}
								});
							}
						}
					}
				}
				else {
					if (isEarnCodeColumn) {
						//iterate through columns, and check the value of the earncode
						$.each(row, (key: string, val) => {
							if (key.indexOf("@Hours") > -1 && val != null && val != "") {
								//get earncode value from column name
								let columnValueParts = key.split("___");
								let earnCode = parseInt(columnValueParts[earnCodeIndex]);
								//if earncode is not excluded, add it to totals
								if (earnCodesToExclude.indexOf(earnCode) == -1) {
									let index = key.search(/\d\d\d\d-\d\d-\d\d/);
									let dateString = key.substr(index, 10);
									//dates are always in the form of yyyy-mm-dd regardless of locale
									if (totalsByEmployee[employee][dateString] == null) {
										totalsByEmployee[employee][dateString] = { timecardHours: 0, otherHours: 0, totalHours: 0 }
										totalsByEmployee[employee][dateString].timecardHours = parseFloat(val);
										totalsByEmployee[employee][dateString].totalHours = parseFloat(val);
									}
									else {
										totalsByEmployee[employee][dateString].timecardHours += parseFloat(val);
										totalsByEmployee[employee][dateString].totalHours += parseFloat(val);
									}
								}
							}
						});
					}
					else {
						//check the row value of earncode to see if it is not an excluded code
						if (row.EarnCode != null && row.EarnCode != "" && row.Earncode != "null") {
							let earnCode = parseInt(row.EarnCode.substr(0, row.EarnCode.indexOf("@")));
							if (earnCodesToExclude.indexOf(earnCode) > -1) {
								exclude = true;
							}
						}
						//if it is not excluded, add the hours to the totals
						if (!exclude) {
							$.each(row, (key: string, val) => {
								if (key.indexOf("@Hours") > -1 && val != null && val != "") {
									let index = key.search(/\d\d\d\d-\d\d-\d\d/);
									let dateString = key.substr(index, 10);
									//dates are always in the form of yyyy-mm-dd regardless of locale
									if (totalsByEmployee[employee][dateString] == null) {
										totalsByEmployee[employee][dateString] = { timecardHours: 0, otherHours: 0, totalHours: 0 }
										totalsByEmployee[employee][dateString].timecardHours = parseFloat(val);
										totalsByEmployee[employee][dateString].totalHours = parseFloat(val);
									}
									else {
										totalsByEmployee[employee][dateString].timecardHours += parseFloat(val);
										totalsByEmployee[employee][dateString].totalHours += parseFloat(val);
									}
								}
							});
						}
					}
				}
			}
		});

		this.getOtherTotals(totalsByEmployee);
		
  }

	getOtherTotals(totalsByEmployee) {
		let employeeString = this.crewTimecardDataService.employees.slice(1, this.crewTimecardDataService.employees.length).map((elem) => { return elem.Value; }).join(",");

		this.crewTimecardGridService.getDailyOtherHours(employeeString, this.crewTimecardDataService.payPeriod.PRCo, this.crewTimecardDataService.payPeriod.PRPCKeyID, this.crewTimecardDataService.template.CrewTemplateID).then((response: any) => {
			response.forEach((item) => {
				let date = moment.utc(item.PostDate);
				let dateString = date.format("YYYY-MM-DD");
				if (totalsByEmployee[item.Employee] == null)
					totalsByEmployee[item.Employee] = {};
				if (totalsByEmployee[item.Employee][dateString] == null) {
					totalsByEmployee[item.Employee][dateString] = { timecardHours: 0, otherHours: 0, totalHours: 0 }
					totalsByEmployee[item.Employee][dateString].otherHours = parseFloat(item.TotalHoursWorkedOnOtherCards);
					totalsByEmployee[item.Employee][dateString].totalHours = parseFloat(item.TotalHoursWorkedOnOtherCards);
				}
				else {
					totalsByEmployee[item.Employee][dateString].otherHours += parseFloat(item.TotalHoursWorkedOnOtherCards);
					totalsByEmployee[item.Employee][dateString].totalHours += parseFloat(item.TotalHoursWorkedOnOtherCards);
				}
      })
			this.crewTimecardDataService.timeWorked.setTimecardTotalsByEmployee(totalsByEmployee);
			//if timecard load was triggered for a clock submit, run clock submit code
			if (this.callback != null && this.callback.callbackType == "clockSubmit") {
				this.callback.callbackFunction();
      }
		});

	}

	//Clone grid helper methods
	getGridDates() {
		let dates = [];
		if (typeof this.gridData != 'undefined') {
			this.gridData.columns.forEach((column) => {
				if (column.id.indexOf("Hours") > 0) {
					let dateString = column.id.match(/\d\d\d\d-\d\d-\d\d/g);
					if (dateString != null && dateString.length > 0 && dateString[0] != null) {
						let date = moment(dateString[0], "YYYY-MM-DD");
						//check if date exists already
						let toDateObj = { Date: date, DisplayDate: moment(date).format("l") };
						if (this.containsObject(toDateObj, dates) == -1) {
							dates.push(toDateObj);
						}
					}
				}
			});
		}
		return dates;
	}

	//Copy row helper methods
	private getCrewsList(row) {
		this.crewTimecardGridService.getCrews(this.crewTimecardDataService.payPeriod.PRCo, this.crewTimecardDataService.payPeriod.PRGroup).then((response: any[]) => {
			this.crewTimecardDataService.crewsList = response;
			if (this.bulkEmployeeList.length == 0) {
				this.getBulkEmployeeList(row);
			}
			else {
				this.openCopyRowModal(row);
			}
		})
	}

	getBulkEmployeeList(row) {
		this.crewTimecardGridService.getBulkEmployeeList(this.crewTimecardDataService.payPeriod.PRCo, this.crewTimecardDataService.payPeriod.PRGroup).then((response: any[]) => {
			let tempEmployeeList = response;
			let callcount = 0;
			for (let i = tempEmployeeList.length - 1; i >= 0; i--) {
				if (this.employeesToExclude.indexOf(tempEmployeeList[i].Employee.toString()) > -1) {
					tempEmployeeList.splice(i, 1);
					callcount++;
					if (callcount == this.employeesToExclude.length)
						break;
				}
			}
			this.bulkEmployeeList = tempEmployeeList;
			this.openCopyRowModal(row);
		});
	}

	openCopyRowModal(row) {
		if (row.isReadOnly != "1") {
			this.processingRow = false;
			this.crewTimecardDataService.loadingValues = false;

			let modalRef = _this.ngbmodalService.open(CopyCrewLineModalComponent, { size: 'lg', backdrop: 'static', keyboard: false });
			modalRef.componentInstance.crewsList = this.crewTimecardDataService.crewsList;
			modalRef.componentInstance.employees = _.cloneDeep(this.bulkEmployeeList);
			modalRef.componentInstance.payPeriod = this.crewTimecardDataService.payPeriod;
			modalRef.componentInstance.row = row;
			modalRef.componentInstance.rowProperties = this.gridData.rowPropertyNames;
			modalRef.componentInstance.sharedColumnInfo = this.sharedColumnInfo;

			

			modalRef.result.then((result: any) => {
				this.crewTimecardDataService.timecardLoaded = false;
				let selectedEmployees = result.selectedEmployees;
				selectedEmployees.forEach((selectedEmployee) => {
					let newRow: any = {};
					this.crewTimecardDataService.newRowID++;
					newRow.id = this.crewTimecardDataService.newRowID;
					
					$.each(row, (rowKey: string, rowVal: any) => {
						if (rowKey == "udSort") {
							this.largestSortID++;
							newRow[rowKey] = this.largestSortID;
						}
						else if (rowKey != "id") {
							if (typeof rowVal == "string") {
								let valIndex = rowVal.indexOf("@row_");
								if (valIndex > -1) {
									let parsedRowVal = rowVal.substr(0, valIndex);
									newRow[rowKey] = parsedRowVal + "@row_" + newRow.id;
									if (this.sharedColumnInfo[rowKey] != null && this.sharedColumnInfo[rowKey].IsCombo == 1 && this.columnOptions[rowKey] != null) {
										this.columnOptions[rowKey].add({ id: parsedRowVal + "@row_" + newRow.id, value: row[rowKey + "___@Value"] });
									}
								}
								else {
									newRow[rowKey] = rowVal;
								}
							}
							else {
								newRow[rowKey] = rowVal;
							}
						}


					});

					//special handling for copying PostDate as webix only recognizes dates in a specific format while adding
					if (this.gridData.rowPropertyNames.indexOf("PostDate") > -1 && row.PostDate != null && typeof row.PostDate.getMonth == 'function') {
						let yyyy = row.PostDate.getFullYear().toString();
						let mm = (row.PostDate.getMonth() + 1).toString();
						let dd = row.PostDate.getDate().toString();
						newRow.PostDate = yyyy + "/" + mm + "/" + dd;
					}
					newRow.isNewRow = true;

					//craft class logic
					if (result.useEmpDefaultCraftClass) {
						if (row.Craft !== undefined) {

							newRow["Craft___@Value"] = selectedEmployee.CraftDisplay;
							if (this.columnOptions["Craft"] != null) {
								newRow.Craft = selectedEmployee.Craft + "@row_" + newRow.id;
								this.columnOptions["Craft"].add({ id: selectedEmployee.Craft + "@row_" + newRow.id, value: selectedEmployee.CraftDisplay });
							}
							else
								newRow.Craft = selectedEmployee.Craft;
						}
						if (row.Class !== undefined) {

							newRow["Class___@Value"] = selectedEmployee.ClassDisplay;
							if (this.columnOptions["Class"] != null) {
								newRow.Class = selectedEmployee.Class + "@row_" + newRow.id
								this.columnOptions["Class"].add({ id: selectedEmployee.Class + "@row_" + newRow.id, value: selectedEmployee.ClassDisplay });
							}
							else
								newRow.Class = selectedEmployee.Class;
						}
					}

					if (result.useEmplDefaultEarnCode && row.EarnCode !== undefined) {
						newRow["EarnCode___@Value"] = selectedEmployee.EarnCodeDisplay;
						if (this.columnOptions["EarnCode"] != null) {
							newRow.EarnCode = selectedEmployee.EarnCode + "@row_" + newRow.id;
							this.columnOptions["EarnCode"].add({ id: selectedEmployee.EarnCode + "@row_" + newRow.id, value: selectedEmployee.EarnCodeDisplay });
						}
						else
							newRow.EarnCode = selectedEmployee.EarnCode;
					}

					//PRDEPT LOGIC
					if (this.sharedColumnInfo["PRDept"] != null && this.sharedColumnInfo["PRDept"].ColumnVisibilityModeID == 3) {
						newRow["PRDept@Value"] = selectedEmployee.PRDeptDisplay;
						if (this.columnOptions["PRDept"] != null) {
							newRow.PRDept = selectedEmployee.PRDept + "@row_" + newRow.id;
							this.columnOptions["PRDept"].add({ id: selectedEmployee.PRDept + "@row_" + newRow.id, value: selectedEmployee.PRDeptDisplay });
						}
					}

					newRow.Employee = selectedEmployee.Employee.toString() + "@row_" + newRow.id;
					this.columnOptions["Employee"].add({ id: selectedEmployee.Employee.toString() + "@row_" + newRow.id, value: selectedEmployee.EmployeeDisplayName });
					newRow["Employee___@Value"] = selectedEmployee.EmployeeDisplayName;
					newRow.IsSubmitted = "0";
					newRow.KeyID = -1;
					this.dataTable.add(newRow, 0);
					this.crewTimecardDataService.timecardLoaded = true;

					//Save Button Visibility
					this.crewTimecardDataService.rowCount++;
					this.crewTimecardDataService.unsubmittedRows++;

					//set time worked read only based on unsubmitted rows
					if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled) {
						this.crewTimecardDataService.timeWorked.setReadOnly(this.crewTimecardDataService.unsubmittedRows < this.crewTimecardDataService.rowCount);
					}

					this.dataTable.refresh();
        })
			}, () => { /*dimissal*/ });
    }
  }

	//Bulk Add helper methods
	getBulkAddColumns() {
		let bulkAddColumns = [];
		let bulkAddDates = [];
		$.each(this.gridData.columnMap, (columnKey, column: any) => {
			if (column.valuePropertyName == "@Hours" || column.valuePropertyName == "@UsageUnits") {
				if (bulkAddDates.length == 0 || bulkAddDates[bulkAddDates.length - 1].DateValue != column.columnValues[0]) {
					let bulkAddDate = { DateDisplay: column.columnDisplayValues[0].replace(/&nbsp;/g, " ").replace(/&#8209;/g, "-").replace("<br />", ' - '), DateValue: column.columnValues[0] };
					bulkAddDates.push(bulkAddDate);
				}
				if (bulkAddDates.length < 2) {
					let columnObj = { ColumnDisplay: "", ColumnName: "" };

					if (column.columnValues.length > 1)
						columnObj.ColumnDisplay = column.columnDisplayValues.slice(1).join(" ") + " " + column.valuePropertyName.substr(1);
					else
						columnObj.ColumnDisplay = column.valuePropertyName.substr(1);
					columnObj.ColumnDisplay = columnObj.ColumnDisplay.replace(/&nbsp;/g, " ").replace(/&#8209;/g, "-").replace("<br />", ' - ');
					columnObj.ColumnName = column.resolvedColumnName.slice(column.resolvedColumnName.indexOf("___") + 3);
					bulkAddColumns.push(columnObj);
				}
			}
		});

		return {
			BulkAddColumns: bulkAddColumns, BulkAddDates: bulkAddDates
		};
	}

	bulkAdd(newRowData, selectedEmployees, bulkAddDates, columnValues) {
		this.bindBulkDefaults(newRowData, selectedEmployees, bulkAddDates, columnValues);
  }

	bindBulkDefaults(newRowData, selectedEmployees, bulkAddDates, columnValues) {
		this.crewTimecardGridService.getDefaultsForEmplList(selectedEmployees.map((x) => { return x.PREHKeyID }).join(",")).then((response: any[]) => {
			let rowsToAdd = [];
			let rowData = { KeyID: "-1", isNewRow: true, Type: newRowData.Type.Value, "Type___@Value": newRowData.Type.Label };

			//copy values to new rowData object
			$.each(newRowData, (key: string, val: any) => {
				//if key is a row property, copy it directly to new object
				if (this.gridData.rowPropertyNames.indexOf(key) > -1) {
					if (this.sharedColumnInfo[key].IsCombo == 1 && val != null) {
						rowData[key] = val.Value;
						rowData[key + "___@Value"] = val.Label;
					}
					else {
						rowData[key] = val;
					}

				}
				//if key is a column propery, copy to new object for each date in selected dates
				else if (this.isValueProperty(key, this.gridData.valuePropertyNames)) {
					bulkAddDates.forEach((bulkAddDate) => {
						rowData[bulkAddDate.DateValue + "___" + key] = val;
					});
				}
			});

			let employeeDefaults = {};

			for (let i = 0; i < response.length; i++) {
				employeeDefaults[response[i].Employee] = response[i];
			}

			for (let i = 0; i < selectedEmployees.length; i++) {
				const employee = selectedEmployees[i];
				let rowCopy: any = _.cloneDeep(rowData);
				rowCopy.Employee = employee.Employee;
				rowCopy["Employee___@Value"] = employee.EmployeeDisplayName;

				//go through each row property; if it is null, check and set a default value 
				for (let j = 0; j < this.gridData.rowPropertyNames.length; j++) {
					const columnName = this.gridData.rowPropertyNames[j];

					if (newRowData[columnName] == null) {
						//Case: New Line Type = Employee Default
						if (this.sharedColumnInfo[columnName].NewLineTypeID == 3) {
							if (employeeDefaults[employee.Employee] != null && employeeDefaults[employee.Employee][columnName] != null) {
								rowCopy[columnName] = employeeDefaults[employee.Employee][columnName];

								if (this.sharedColumnInfo[columnName].IsCombo == 1)
									rowCopy[columnName + "___@Value"] = employeeDefaults[employee.Employee][columnName + "Label"];
							}
						}
						//TODO Case: New Line Type = Previous Value
					}
					else if (newRowData[columnName].Value != null && newRowData[columnName].Value == "-1") {
						rowCopy[columnName] = null;
						rowCopy[columnName + "___@Value"] = null;
					}
				}
				rowsToAdd.push(rowCopy);
			}

			let tempArray = [];
			for (let i = rowsToAdd.length - 1; i >= 0; i--) {
				tempArray.push(rowsToAdd[i]);
			}
			this.bulkAddCTRows(tempArray);
		});
	}

	bulkAddCTRows(rowsToAdd) {
		let callback = (addedRows) => {
			addedRows.forEach((row) => {
				$.each(row, (key: string, val) => {
					if (this.gridData.rowPropertyNames.indexOf(key) > -1 && this.columnOptions[key] != null) {
						if (this.columnOptions[key].getItem(row[key]) == null) {
							this.columnOptions[key].add({ id: row[key], value: row[key + "___@Value"], visible: true });
						}
					}
				});
			});
    }

		this.crewTimecardManagerService.addRows(rowsToAdd, this.dataTable, callback);
		this.crewTimecardDataService.unsavedChanges = true;
		this.crewTimecardDataService.rowCount += rowsToAdd.length;
		this.crewTimecardDataService.unsubmittedRows += rowsToAdd.length;
		this.crewTimecardDataService.newRowID += rowsToAdd.length;
		this.crewTimecardDataService.timecardLoaded = true;

		//set time worked read only based on unsubmitted rows
		if (this.crewTimecardDataService.payPeriod.IsTimeWorkedEnabled) {
			this.crewTimecardDataService.timeWorked.setReadOnly(this.crewTimecardDataService.unsubmittedRows < this.crewTimecardDataService.rowCount);
		}

		this.dataTable.refresh();
  }

	//This exists because propertynames can be complex and contain other characters
	isValueProperty(propertyName, propertyNames) {
		for (var i = 0; i < propertyNames.length; i++) {
			if (propertyName.indexOf(propertyNames[i]) > -1)
				return true;
		}
		return false;
	}

	//helper methods

	private containsObject(obj, list): number {
		let i;
		for (i = 0; i < list.length; i++) {
			if (_.isEqual(list[i], obj)) {
				return i;
			}
		}
		return -1;
	}

	private columnExists(columnName): boolean {
		if (columnName == null || columnName == "")
			return false;
		for (var i = 0; i < this.gridData.columns.length; i++) {
			if (this.gridData.columns[i].id == columnName)
				return true;
		}
		return false;
  }

	private dropdownSort(column) {
		return (a, b) => {
			if (column == "Employee" && this.portalSettings.RemoveEmployeeNumberFromDropdown.ConfigValue != "1" && this.portalSettings.ShowLastFirstFormat.ConfigValue != "1") {
				valueA = (a.Employee != null && a.Value != "") ? parseInt(a.Employee.substr(0, a.Employee.indexOf("@"))) : 0;
				valueB = (b.Employee != null && b.Value != "") ? parseInt(b.Employee.substr(0, b.Employee.indexOf("@"))) : 0;
			}
			else {
				var valueA, valueB;
				valueA = a[column + "___@Value"];
				valueB = b[column + "___@Value"];
			}
			return valueA > valueB ? 1 : (valueA < valueB ? -1 : 0);
		}
	}

	private valueSort(column) {
		return (a, b) => {
			if (column == "Employee" && this.portalSettings.RemoveEmployeeNumberFromDropdown.ConfigValue != "1" && this.portalSettings.ShowLastFirstFormat.ConfigValue != "1") {
				a = (a != null && a != "") ? parseInt(a.substr(0, a.indexOf("@"))) : 0;
				b = (b != null && b != "") ? parseInt(b.substr(0, b.indexOf("@"))) : 0;
			}
			return a > b ? 1 : (a < b ? -1 : 0);
		}

	}

	private employeeDropdownSort(a, b) {
		let employeeA, employeeB;
		if (_this.portalSettings.RemoveEmployeeNumberFromDropdown.ConfigValue != "1") {
			employeeA = (a.Value != null && a.Value != "") ? parseInt(a.Value) : 0;
			employeeB = (b.Value != null && b.Value != "") ? parseInt(b.Value) : 0;
		}
		else {
			employeeA = a.Label;
			employeeB = b.Label;
		}

		return employeeA > employeeB ? 1 : (employeeA < employeeB ? -1 : 0);
  }

	public escapeHtml(unsafe: string) {
		return unsafe
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#039;");
  }

	private isAmountRow(rowID) {
		let row = this.dataTable.getItem(rowID);
		let rowLineType = row.Type != null ? row.Type.substr(0, row.Type.indexOf("@")) : "J";
		if (rowLineType != "S" && row.EarnCode != null && row.EarnCode.substr(0, row.EarnCode.indexOf("@")) != "") {
			let earnCode = row.EarnCode.substr(0, row.EarnCode.indexOf("@"));
			if (this.amountEarnCodes.indexOf(earnCode) > -1) {
				return true;
			}
		}
		else if (rowLineType == "S" && row.PayType != null && row.PayType.substr(0, row.PayType.indexOf("@")) != "") {
			let payType = row.EarnCode.substr(0, row.EarnCode.indexOf("@"));
			if (this.amountPayTypes.indexOf(payType) > -1) {
				return true
			}
		}
		return false;
	}

	private isCellReadOnly(row, columnName) {
		if (row.Type == null) {
			return false;
		}

		if (this.sharedColumnInfo[columnName] == null) {
			return true;
		}

		let rowLineType = row.Type.substr(0, row.Type.indexOf("@"));
		let colLineType = this.sharedColumnInfo[columnName].LineType;
		if (rowLineType == "J") {
			if (colLineType != "J" && colLineType != "A" && colLineType != "F" && colLineType != "T") {
				return true;
			}
			else
				return false;
		}
		else if (rowLineType == "S") {
			if ((colLineType != "S" && colLineType != "A" && colLineType != "T") || columnName == "Job") {
				return true;
			}
			else
				return false;
		}
		else if (rowLineType == "M") {
			if (colLineType != "M" && colLineType != "A" && colLineType != "F") {
				return true;
			}
			else
				return false;
		}
		else
			return false;
	}

	private isNumber(input) {
		if (input == null || !isNaN(input))
			return true;
		return false;
	}

	private isInteger(input) {
		if (input == null || (!isNaN(input) && input % 1 == 0))
			return true;
		return false;
	}

	windowResize() {
		window.onresize = (event) => {
			if (this.dataTable != null) {
				let height = $(document).height() - $("#crewActionBar").height() - 170;
				this.dataTable.config.height = Math.max(height, 300);
				this.dataTable.resize();
			}
		}
	}

  ngOnDestroy() {
    this.dataTable.destructor();
  }

}
